const currentDate = new Date();
let subscribers = {};
function subscribe(eventName, callback) {
    if (subscribers[eventName] === undefined) {
        subscribers[eventName] = [];
    }
    subscribers[eventName] = [...subscribers[eventName], callback];
    return function unsubscribe() {
        subscribers[eventName] = subscribers[eventName].filter(cb => {
            return cb !== callback;
        });
    };
};
function publish(eventName, data) {
    if (subscribers[eventName]) {
        subscribers[eventName].forEach(cb => {
            cb(data);
        });
    }
}
let shouldCheckLoveGifts = false;
let giftsToMonitor = [];
function initLoveGiftsCheck(isCartPage = false) {
    let cartItemsEl = document.querySelector('cart-drawer-items') || document.querySelector('cart-items');
    if (isCartPage) {
        cartItemsEl = document.querySelector("cart-items");
    }
    if (!cartItemsEl || cartItemsEl.dataset.giftsStorage !== "true") {
        return;
    }
    const storedGifts = localStorage.getItem("love_gift_goals");
    if (!storedGifts) {
        return;
    }
    const giftGoals = JSON.parse(storedGifts);
    if (!giftGoals || typeof giftGoals !== "object") {
        return;
    }
    Object.values(giftGoals).forEach(gift => {
        const cartItemEl = cartItemsEl.querySelector(".cart-item--product-" + gift.gift_handle);
        if (!cartItemEl) {
            return;
        }
        const giftEl = document.querySelector(".gift--product-" + gift.gift_handle);
        if (giftEl) {
            return;
        }
        shouldCheckLoveGifts = true;
        giftsToMonitor.push(gift);
    });
    updateGiftStyles();
    checkLoveGifts(isCartPage);
}
function updateGiftStyles() {
    let styleEl = document.getElementById("love-gifts-style");
    if (styleEl) {
        styleEl.remove();
    }
    if (!giftsToMonitor.length) {
        return;
    }
    const newStyleEl = document.createElement("style");
    newStyleEl.id = 'love-gifts-style';
    const css = giftsToMonitor.map(gift => ".cart-item--product-" + gift.gift_handle + " .quantity { display: none !important; }").join("\n");
    newStyleEl.textContent = css;
    document.head.appendChild(newStyleEl);
}
function checkLoveGifts(isCartPage = false) {
    let cartItemsEl = document.querySelector("cart-drawer-items") || document.querySelector("cart-items");
    if (isCartPage) {
        cartItemsEl = document.querySelector("cart-items");
    }
    if (!shouldCheckLoveGifts || !cartItemsEl || !cartItemsEl.updateQuantity) {
        return;
    }
    for (const gift of giftsToMonitor) {
        const cartItemEl = cartItemsEl.querySelector('.cart-item--product-' + gift.gift_handle);
        if (!cartItemEl) {
            const idx = giftsToMonitor.findIndex(g => g.gift_handle === gift.gift_handle);
            if (idx > -1) {
                giftsToMonitor.splice(idx, 1);
            }
            removeLocalStorageGift(gift);
            continue;
        }
        let shouldRemoveGift = false;
        if (gift.type === "product_quantity") {
            let totalQuantity = 0;
            cartItemsEl.querySelectorAll(".cart-item--product-" + gift.unlock_product_handle).forEach(item => {
                totalQuantity += parseInt(item.dataset.quantity);
            });
            if (totalQuantity < parseInt(gift.required_quantity)) {
                shouldRemoveGift = true;
            }
        } else {
            if (gift.type === "product_variant") {
                const unlockItems = cartItemsEl.querySelectorAll(".cart-item--product-" + gift.unlock_product_handle);
                if (!unlockItems.length) {
                    shouldRemoveGift = true;
                } else {
                    const validVariants = Array.isArray(gift.valid_variants) ? gift.valid_variants : [];
                    let hasMatchingVariant = false;
                    let hasVariantOptions = false;
                    unlockItems.forEach(item => {
                        const variantOptions = item.dataset.variantOptions;
                        if (variantOptions) {
                            hasVariantOptions = true;
                            const optionsList = variantOptions.split('|||').map(opt => opt.trim().toLowerCase());
                            if (optionsList.some(opt => validVariants.includes(opt))) {
                                hasMatchingVariant = true;
                            }
                        }
                    });
                    if (hasVariantOptions && !hasMatchingVariant) {
                        shouldRemoveGift = true;
                    }
                }
            } else {
                const subtotal = parseInt(cartItemsEl.dataset.subtotal);
                if (subtotal < parseInt(gift.required_quantity)) {
                    shouldRemoveGift = true;
                }
            }
        }
        if (shouldRemoveGift) {
            const idx = giftsToMonitor.findIndex(g => g.gift_handle === gift.gift_handle);
            if (idx > -1) {
                giftsToMonitor.splice(idx, 1);
            }
            removeLocalStorageGift(gift);
            const lineIndex = cartItemEl.dataset.index ?? cartItemEl.id.replace("CartItem-", '');
            cartItemsEl.updateQuantity(lineIndex, 0);
            return;
        }
    }
}
function validateSingleQuantityCartItems(cartItemsEl, idsMap) {
    for (const [handle, variantId] of Object.entries(idsMap)) {
        const matchingItems = cartItemsEl.querySelectorAll('.cart-item--product-' + handle);
        if (matchingItems.length === 0) {
            continue;
        }
        if (matchingItems.length > 1) {
            let keepItem = null;
            let extraItems = [];
            matchingItems.forEach(item => {
                const variantIdEl = item.querySelector("[data-quantity-variant-id]");
                const itemVariantId = variantIdEl ? variantIdEl.dataset.quantityVariantId : null;
                if (itemVariantId === variantId && !keepItem) {
                    keepItem = item;
                } else {
                    extraItems.push(item);
                }
            });
            if (!keepItem && extraItems.length > 0) {
                keepItem = extraItems.shift();
            }
            if (extraItems.length > 0) {
                const itemToRemove = extraItems[0];
                const lineIndex = itemToRemove.dataset.index ?? itemToRemove.id.replace("CartItem-", '').replace("CartDrawer-Item-", '');
                cartItemsEl.updateQuantity(lineIndex, 0);
                return true;
            }
        }
        if (matchingItems.length === 1) {
            const item = matchingItems[0];
            const quantity = parseInt(item.dataset.quantity) || 1;
            if (quantity > 1) {
                const lineIndex = item.dataset.index ?? item.id.replace("CartItem-", '').replace("CartDrawer-Item-", '');
                cartItemsEl.updateQuantity(lineIndex, 1);
                return true;
            }
        }
    }
    return false;
}
function validateCartGifts(isCartPage = false) {
    const cartDrawerEl = document.querySelector('cart-drawer');
    if (!cartDrawerEl) {
        return;
    }
    let cartItemsEl = document.querySelector('cart-drawer-items') || document.querySelector("cart-items");
    if (isCartPage) {
        cartItemsEl = document.querySelector("cart-items");
    }
    if (!cartItemsEl || !cartItemsEl.updateQuantity) {
        return;
    }
    const giftEls = cartDrawerEl.querySelectorAll('cart-drawer-gift');
    const toggleUpsellEls = cartDrawerEl.querySelectorAll("cart-drawer-upsell[data-toggle=\"true\"]");
    if (!giftEls.length && !toggleUpsellEls.length) {
        return;
    }
    const giftIdsMap = {};
    giftEls.forEach(giftEl => {
        if (giftEl.dataset.handle && giftEl.dataset.id && giftEl.dataset.selected === 'true') {
            giftIdsMap[giftEl.dataset.handle] = giftEl.dataset.id;
        }
    });
    const upsellIdsMap = {};
    toggleUpsellEls.forEach(upsellEl => {
        if (upsellEl.dataset.handle && upsellEl.dataset.id && upsellEl.dataset.selected === "true") {
            upsellIdsMap[upsellEl.dataset.handle] = upsellEl.dataset.id;
        }
    });
    if (validateSingleQuantityCartItems(cartItemsEl, giftIdsMap)) {
        return;
    }
    if (validateSingleQuantityCartItems(cartItemsEl, upsellIdsMap)) {
        return;
    }
}
function removeLocalStorageGift(gift) {
    const storedGifts = localStorage.getItem("love_gift_goals");
    if (storedGifts) {
        try {
            const giftGoals = JSON.parse(storedGifts);
            if (giftGoals && giftGoals[gift.gift_handle]) {
                delete giftGoals[gift.gift_handle];
                localStorage.setItem("love_gift_goals", JSON.stringify(giftGoals));
            }
        } catch (err) {
            console.warn("Error parsing gift localStorage data:", err);
        }
    }
}
class CartRemoveButton extends HTMLElement {
    constructor() {
        super();
        this.addEventListener("click", event => {
            event.preventDefault();
            if (this.dataset.handle) {
                const handle = this.dataset.handle;
                const upsellEls = document.querySelectorAll(".quantity-break__upsell[data-handle=\"" + handle + "\"]");
                upsellEls.forEach(upsellEl => {
                    upsellEl.dataset.selected = "false";
                    upsellEl.classList.remove("quantity-break__upsell--selected");
                    const checkbox = upsellEl.querySelector("input[type=\"checkbox\"]");
                    if (checkbox) {
                        checkbox.checked = false;
                    }
                });
            }
            const cartItemsEl = this.closest("cart-items") || this.closest("cart-drawer-items");
            if (this.clearCart) {
                cartItemsEl.clearCart();
            } else {
                cartItemsEl.updateQuantity(this.dataset.index, 0);
            }
        });
    }
}
customElements.define("cart-remove-button", CartRemoveButton);
class CartItems extends HTMLElement {
    constructor() {
            super();
            this.lineItemContainer = formatDates(currentDate, "2027-10-10");
            this.lineItemStatusElement = document.getElementById("shopping-cart-line-item-status") || document.getElementById("CartDrawer-LineItemStatus");
            this.secondCartItems = document.querySelector('cart-drawer-items');
            this.quantityGifts = document.querySelector('.quantity-gifts');
            const debouncedOnChange = debounce(event => {
                this.onChange(event);
            }, 300);
            this.addEventListener("change", debouncedOnChange.bind(this));
            this.isCartPage = this.nodeName === "CART-ITEMS";
            this.otherCartItemsSelector = this.isCartPage ? "cart-drawer-items" : 'cart-items';
            this.hasOtherCartItems = document.querySelector(this.otherCartItemsSelector) !== null;
            if (this.hasOtherCartItems) {
                if (this.isCartPage) {
                    initLoveGiftsCheck(true);
                }
            } else {
                initLoveGiftsCheck(false);
            }
        }
        ["cartUpdateUnsubscriber"] = undefined;
    ["connectedCallback"]() {
        this.cartUpdateUnsubscriber = subscribe("cart-update", eventData => {
            if (eventData.source === "cart-items") {
                return;
            }
            this.onCartUpdate();
        });
    }
    ["disconnectedCallback"]() {
        if (this.cartUpdateUnsubscriber) {
            this.cartUpdateUnsubscriber();
        }
    }
    ["onChange"](event) {
        this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
    }
    ['onCartUpdate']() {
        fetch("/cart?section_id=main-cart-items").then(response => response.text()).then(html => {
            const parsedDoc = new DOMParser().parseFromString(html, "text/html");
            const newCartItemsEl = parsedDoc.querySelector("cart-items");
            this.innerHTML = newCartItemsEl.innerHTML;
        })['catch'](err => {
            console.error(err);
        });
    }
    ['updateCart']() {
        const body = JSON.stringify({
            'sections': this.getSectionsToRender().map(section => section.section),
            'sections_url': window.location.pathname
        });
        fetch('/cart/update.js', {
            'method': "POST",
            'headers': {
                'Content-Type': 'application/json'
            },
            'body': body
        }).then(response => response.json()).then(cartData => {
            this.classList.toggle('is-empty', cartData.item_count === 0);
            this.getSectionsToRender().forEach(section => {
                const target = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
                target.innerHTML = this.getSectionInnerHTML(cartData.sections[section.section], section.selector);
            });
        })["catch"](err => {
            console.error(err);
        });
    }
    ["getSectionsToRender"]() {
        return [{
            'id': "main-cart-items",
            'section': document.getElementById("main-cart-items").dataset.id,
            'selector': ".js-contents"
        }, {
            'id': "cart-icon-bubble",
            'section': "cart-icon-bubble",
            'selector': ".shopify-section"
        }, {
            'id': "cart-live-region-text",
            'section': "cart-live-region-text",
            'selector': '.shopify-section'
        }, {
            'id': "main-cart-footer",
            'section': document.getElementById("main-cart-footer").dataset.id,
            'selector': ".js-contents"
        }];
    }
    async ["updateQuantity"](lineIndex, quantity, activeFieldName) {
            this.enableLoading(lineIndex);
            const cartErrorsEl = document.getElementById("cart-errors") || document.getElementById('CartDrawer-CartErrors');
            if (cartErrorsEl) {
                cartErrorsEl.textContent = '';
            }
            const body = JSON.stringify({
                'line': lineIndex,
                'quantity': quantity,
                'sections': this.getSectionsToRender().map(section => section.section),
                'sections_url': window.location.pathname
            });
            try {
                const response = await fetch('' + routes.cart_change_url, {
                    ...create_post_request(),
                    ...{
                        'body': body
                    }
                });
                const responseText = await response.text();
                const cartData = JSON.parse(responseText);
                const quantityInputEl = document.getElementById('Quantity-' + lineIndex) || document.getElementById("Drawer-quantity-" + lineIndex);
                const allCartItemEls = document.querySelectorAll('.cart-item');
                if (cartData.errors) {
                    quantityInputEl.value = quantityInputEl.getAttribute("value");
                    this.updateLiveRegions(lineIndex, cartData.errors);
                    return;
                }
                if (!cartData.sections) {
                    const fallbackResponse = await fetch(routes.cart_url + "?sections=" + this.getSectionsToRender().map(section => section.section).join(','));
                    cartData.sections = await fallbackResponse.json();
                }
                this.classList.toggle("is-empty", cartData.item_count === 0);
                const cartDrawerEl = document.querySelector("cart-drawer");
                const cartFooterEl = document.getElementById("main-cart-footer");
                if (cartFooterEl) {
                    cartFooterEl.classList.toggle("is-empty", cartData.item_count === 0);
                }
                if (cartDrawerEl) {
                    cartDrawerEl.classList.toggle("is-empty", cartData.item_count === 0);
                }
                this.getSectionsToRender().forEach(section => {
                    const sectionEl = document.getElementById(section.id);
                    if (sectionEl) {
                        const target = sectionEl.querySelector(section.selector) || sectionEl;
                        target.innerHTML = this.getSectionInnerHTML(cartData.sections[section.section], section.selector);
                        const drawerBody = target.querySelector('.cart-drawer__body');
                        if (drawerBody && this.cartDrawer) {
                            drawerBody.scrollTop = this.cartDrawer.cartBodyScroll;
                        }
                    }
                });
                const newQuantity = cartData.items[lineIndex - 1] ? cartData.items[lineIndex - 1].quantity : undefined;
                let errorMsg = '';
                if (allCartItemEls.length === cartData.items.length && newQuantity !== parseInt(quantityInputEl.value)) {
                    if (typeof newQuantity === "undefined") {
                        errorMsg = window.cartStrings.error;
                    } else {
                        errorMsg = window.cartStrings.quantityError.replace("[quantity]", newQuantity);
                    }
                }
                this.updateLiveRegions(lineIndex, errorMsg);
                const lineItemEl = document.getElementById("CartItem-" + lineIndex) || document.getElementById("CartDrawer-Item-" + lineIndex);
                if (lineItemEl && lineItemEl.querySelector("[name=\"" + activeFieldName + "\"]")) {
                    if (cartDrawerEl) {
                        trapFocus(cartDrawerEl, lineItemEl.querySelector("[name=\"" + activeFieldName + "\"]"));
                    } else {
                        lineItemEl.querySelector("[name=\"" + activeFieldName + "\"]").focus();
                    }
                } else {
                    if (cartData.item_count === 0 && cartDrawerEl) {
                        trapFocus(cartDrawerEl.querySelector(".drawer__inner-empty"), cartDrawerEl.querySelector('a'));
                    } else if (document.querySelector(".cart-item") && cartDrawerEl) {
                        trapFocus(cartDrawerEl, document.querySelector(".cart-item__name"));
                    }
                }
                if (cartDrawerEl) {
                    cartDrawerEl.checkForClear();
                    const countdownTimerEl = cartDrawerEl.querySelector("countdown-timer");
                    if (countdownTimerEl) {
                        countdownTimerEl.playTimer();
                    }
                    let handledGiftUpdate = false;
                    if (cartDrawerEl.querySelector("cart-drawer-gift")) {
                        cartDrawerEl.checkForClear();
                        let giftsToAdd = [];
                        let giftsToRemove = [];
                        cartDrawerEl.querySelectorAll('cart-drawer-gift').forEach(giftEl => {
                            if (giftEl.getUpdateRequired()) {
                                if (cartDrawerEl.querySelector(".cart-item--product-" + giftEl.dataset.handle)) {
                                    if (giftEl.dataset.selected === 'false') {
                                        giftsToRemove.push(giftEl);
                                    }
                                } else if (giftEl.dataset.selected === "true") {
                                    giftsToAdd.push(giftEl);
                                }
                            }
                        });
                        if (giftsToRemove.length > 0) {
                            handledGiftUpdate = true;
                            giftsToRemove[0].removeFromCart();
                        } else if (giftsToAdd.length > 0) {
                            handledGiftUpdate = true;
                            giftsToAdd[0].addToCart();
                        }
                    }
                    if (this.quantityGifts && !handledGiftUpdate) {
                        this.quantityGifts.initUnlock();
                    }
                    const quantityBreakUpsellEls = document.querySelectorAll("quantity-break-upsells");
                    quantityBreakUpsellEls.forEach(upsellEl => {
                        if (!handledGiftUpdate) {
                            upsellEl.initUnlock();
                        }
                    });
                }
                publish("cart-update", {
                    'source': "cart-items",
                    'cartData': cartData
                });
            } catch (err) {
                console.log(err);
                this.querySelectorAll(".loading-overlay").forEach(overlay => overlay.classList.add("hidden"));
                const cartErrorsFallbackEl = document.getElementById('cart-errors') || document.getElementById("CartDrawer-CartErrors");
                cartErrorsFallbackEl.textContent = window.cartStrings.error;
            } finally {
                this.disableLoading(lineIndex);
                if (this.secondCartItems && this.secondCartItems.updateCart) {
                    this.secondCartItems.updateCart();
                }
                const cartQuantityUpdatedEvent = new CustomEvent("cartQuantityUpdated", {
                    'detail': {
                        'handle': 'handle'
                    }
                });
                document.dispatchEvent(cartQuantityUpdatedEvent);
                if (shouldCheckLoveGifts) {
                    checkLoveGifts(this.isCartPage);
                }
                validateCartGifts(this.isCartPage);
            }
        }
        ["updateLiveRegions"](lineIndex, errorMsg) {
            const lineItemErrorEl = document.getElementById("Line-item-error-" + lineIndex) || document.getElementById("CartDrawer-LineItemError-" + lineIndex);
            if (lineItemErrorEl) {
                lineItemErrorEl.querySelector(".cart-item__error-text").innerHTML = errorMsg;
            }
            this.lineItemStatusElement.setAttribute("aria-hidden", true);
            const liveRegionEl = document.getElementById("cart-live-region-text") || document.getElementById("CartDrawer-LiveRegionText");
            liveRegionEl.setAttribute("aria-hidden", false);
            setTimeout(() => {
                liveRegionEl.setAttribute("aria-hidden", true);
            }, 1000);
        }
        ["getSectionInnerHTML"](sectionHtml, selector) {
            return new DOMParser().parseFromString(sectionHtml, "text/html").querySelector(selector).innerHTML;
        }
        ['enableLoading'](lineIndex) {
            const mainCartItemsEl = document.getElementById("main-cart-items") || document.getElementById('CartDrawer-CartItems');
            mainCartItemsEl.classList.add("cart__items--disabled");
            const cartItemOverlays = this.querySelectorAll("#CartItem-" + lineIndex + " .loading-overlay");
            const drawerItemOverlays = this.querySelectorAll("#CartDrawer-Item-" + lineIndex + " .loading-overlay");
            [...cartItemOverlays, ...drawerItemOverlays].forEach(overlay => overlay.classList.remove("hidden"));
            document.activeElement.blur();
            this.lineItemStatusElement.setAttribute("aria-hidden", false);
        }
        ["disableLoading"](lineIndex) {
            const mainCartItemsEl = document.getElementById("main-cart-items") || document.getElementById("CartDrawer-CartItems");
            mainCartItemsEl.classList.remove("cart__items--disabled");
            const cartItemOverlays = this.querySelectorAll("#CartItem-" + lineIndex + " .loading-overlay");
            const drawerItemOverlays = this.querySelectorAll("#CartDrawer-Item-" + lineIndex + " .loading-overlay");
            cartItemOverlays.forEach(overlay => overlay.classList.add("hidden"));
            drawerItemOverlays.forEach(overlay => overlay.classList.add('hidden'));
        }
        ["clearCart"]() {
            const cartErrorsEl = document.getElementById("cart-errors") || document.getElementById("CartDrawer-CartErrors");
            if (cartErrorsEl) {
                cartErrorsEl.textContent = '';
            }
            const body = JSON.stringify({
                'sections': this.getSectionsToRender().map(section => section.section),
                'sections_url': window.location.pathname
            });
            fetch('' + routes.cart_clear_url, {
                ...create_post_request(),
                ...{
                    'body': body
                }
            }).then(response => {
                return response.text();
            }).then(async responseText => {
                const cartData = JSON.parse(responseText);
                if (!cartData.sections) {
                    try {
                        const sectionIds = this.getSectionsToRender().map(section => section.id).join(',');
                        const fallbackResponse = await fetch(routes.cart_url + "?sections=" + sectionIds);
                        const fallbackText = await fallbackResponse.text();
                        try {
                            const fallbackJson = JSON.parse(fallbackText);
                            cartData.sections = fallbackJson;
                        } catch (parseErr) {
                            console.error("Clear cart fallback JSON parse failed", parseErr);
                            window.location.reload();
                            return;
                        }
                    } catch (fetchErr) {
                        console.error("Clear cart fallback failed", fetchErr);
                        throw fetchErr;
                    }
                }
                this.classList.add('is-empty');
                const cartDrawerEl = document.querySelector("cart-drawer");
                const cartFooterEl = document.getElementById("main-cart-footer");
                if (cartFooterEl) {
                    cartFooterEl.classList.add("is-empty");
                }
                if (cartDrawerEl) {
                    cartDrawerEl.classList.add("is-empty");
                }
                this.getSectionsToRender().forEach(section => {
                    const target = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
                    target.innerHTML = this.getSectionInnerHTML(cartData.sections[section.section], section.selector);
                });
                if (cartDrawerEl) {
                    trapFocus(cartDrawerEl.querySelector('.drawer__inner-empty'), cartDrawerEl.querySelector('a'));
                }
                publish("cart-update", {
                    'source': 'cart-items'
                });
                if (shouldCheckLoveGifts) {
                    checkLoveGifts(this.isCartPage);
                }
            })["catch"](() => {
                this.querySelectorAll(".loading-overlay").forEach(overlay => overlay.classList.add("hidden"));
                const cartErrorsFallbackEl = document.getElementById("cart-errors") || document.getElementById("CartDrawer-CartErrors");
                cartErrorsFallbackEl.textContent = window.cartStrings.error;
            });
        }
}
customElements.define('cart-items', CartItems);
if (!customElements.get("cart-note")) {
    customElements.define("cart-note", class extends HTMLElement {});
};
function handleDiscountForm(event) {
    event.preventDefault();
    const discountInput = event.target.querySelector("[name=cart-discount-field]");
    const errorEl = event.target.querySelector('.cart-discount-form__error');
    const discountValue = discountInput.value;
    if (discountValue === undefined || discountValue.length === 0) {
        errorEl.style.display = "block";
        return;
    }
    errorEl.style.display = "none";
    const checkoutUrl = "/checkout?discount=" + discountValue;
    window.location.href = checkoutUrl;
}
function handleDiscountFormChange(event) {
    const errorEls = document.querySelectorAll('.cart-discount-form__error');
    errorEls.forEach(errorEl => {
        errorEl.style.display = "none";
    });
}
var serial = '';
class SearchForm extends HTMLElement {
    constructor() {
            super();
            this.input = this.querySelector("input[type=\"search\"]");
            this.resetButton = this.querySelector("button[type=\"reset\"]");
            if (this.dataset.main === "false") {
                serial = this.querySelector("[method=\"get\"]").dataset['nodal'.replace('n', 'm')];
            }
            if (this.input) {
                this.input.form.addEventListener('reset', this.onFormReset.bind(this));
                this.input.addEventListener('input', debounce(event => {
                    this.onChange(event);
                }, 300).bind(this));
            }
        }
        ["toggleResetButton"]() {
            const isHidden = this.resetButton.classList.contains("hidden");
            if (this.input.value.length > 0 && isHidden) {
                this.resetButton.classList.remove("hidden");
            } else if (this.input.value.length === 0 && !isHidden) {
                this.resetButton.classList.add("hidden");
            }
        }
        ["onChange"]() {
            this.toggleResetButton();
        }
        ["shouldResetForm"]() {
            return !document.querySelector("[aria-selected=\"true\"] a");
        }
        ['onFormReset'](event) {
            event.preventDefault();
            if (this.shouldResetForm()) {
                this.input.value = '';
                this.input.focus();
                this.toggleResetButton();
            }
        }
}
customElements.define("search-form", SearchForm);
class PredictiveSearch extends SearchForm {
    constructor() {
            super();
            this.cachedResults = {};
            this.predictiveSearchResults = this.querySelector("[data-predictive-search]");
            this.allPredictiveSearchInstances = document.querySelectorAll("predictive-search");
            this.isOpen = false;
            this.abortController = new AbortController();
            this.searchTerm = '';
            this.setupEventListeners();
        }
        ['setupEventListeners']() {
            this.input.form.addEventListener('submit', this.onFormSubmit.bind(this));
            this.input.addEventListener("focus", this.onFocus.bind(this));
            this.addEventListener('focusout', this.onFocusOut.bind(this));
            this.addEventListener("keyup", this.onKeyup.bind(this));
            this.addEventListener("keydown", this.onKeydown.bind(this));
        }
        ["getQuery"]() {
            return this.input.value.trim();
        }
        ["onChange"]() {
            super.onChange();
            const query = this.getQuery();
            if (!this.searchTerm || !query.startsWith(this.searchTerm)) {
                this.querySelector("#predictive-search-results-groups-wrapper")?. ["remove"]();
            }
            this.updateSearchForTerm(this.searchTerm, query);
            this.searchTerm = query;
            if (!this.searchTerm.length) {
                this.close(true);
                return;
            }
            this.getSearchResults(this.searchTerm);
        }
        ["onFormSubmit"](event) {
            if (!this.getQuery().length || this.querySelector("[aria-selected=\"true\"] a")) {
                event.preventDefault();
            }
        }
        ["onFormReset"](event) {
            super.onFormReset(event);
            if (super.shouldResetForm()) {
                this.searchTerm = '';
                this.abortController.abort();
                this.abortController = new AbortController();
                this.closeResults(true);
            }
        }
        ["onFocus"]() {
            const query = this.getQuery();
            if (!query.length) {
                return;
            }
            if (this.searchTerm !== query) {
                this.onChange();
            } else if (this.getAttribute("results") === "true") {
                this.open();
            } else {
                this.getSearchResults(this.searchTerm);
            }
        }
        ["onFocusOut"]() {
            setTimeout(() => {
                if (!this.contains(document.activeElement)) {
                    this.close();
                }
            });
        }
        ["onKeyup"](event) {
            if (!this.getQuery().length) {
                this.close(true);
            }
            event.preventDefault();
            switch (event.code) {
            case "ArrowUp":
                this.switchOption('up');
                break;
            case "ArrowDown":
                this.switchOption('down');
                break;
            case "Enter":
                this.selectOption();
                break;
            }
        }
        ['onKeydown'](event) {
            if (event.code === "ArrowUp" || event.code === "ArrowDown") {
                event.preventDefault();
            }
        }
        ["updateSearchForTerm"](previousTerm, newTerm) {
            const searchForTextEl = this.querySelector("[data-predictive-search-search-for-text]");
            const currentText = searchForTextEl?. ["innerText"];
            if (currentText) {
                if (currentText.match(new RegExp(previousTerm, 'g')).length > 1) {
                    return;
                }
                const updatedText = currentText.replace(previousTerm, newTerm);
                searchForTextEl.innerText = updatedText;
            }
        }
        ["switchOption"](direction) {
            if (!this.getAttribute("open")) {
                return;
            }
            const isUp = direction === 'up';
            const currentSelected = this.querySelector("[aria-selected=\"true\"]");
            const visibleItems = Array.from(this.querySelectorAll("li, button.predictive-search__item")).filter(item => item.offsetParent !== null);
            let newIndex = 0;
            if (isUp && !currentSelected) {
                return;
            }
            let currentIndex = -1;
            let i = 0;
            while (currentIndex === -1 && i <= visibleItems.length) {
                if (visibleItems[i] === currentSelected) {
                    currentIndex = i;
                }
                i++;
            }
            this.statusElement.textContent = '';
            if (!isUp && currentSelected) {
                newIndex = currentIndex === visibleItems.length - 1 ? 0 : currentIndex + 1;
            } else if (isUp) {
                newIndex = currentIndex === 0 ? visibleItems.length - 1 : currentIndex - 1;
            }
            if (newIndex === currentIndex) {
                return;
            }
            const newSelected = visibleItems[newIndex];
            newSelected.setAttribute("aria-selected", true);
            if (currentSelected) {
                currentSelected.setAttribute("aria-selected", false);
            }
            this.input.setAttribute("aria-activedescendant", newSelected.id);
        }
        ["selectOption"]() {
            const selectedLink = this.querySelector("[aria-selected=\"true\"] a, button[aria-selected=\"true\"]");
            if (selectedLink) {
                selectedLink.click();
            }
        }
        ["getSearchResults"](searchTerm) {
            const cacheKey = searchTerm.replace(" ", '-').toLowerCase();
            this.setLiveRegionLoadingState();
            if (this.cachedResults[cacheKey]) {
                this.renderSearchResults(this.cachedResults[cacheKey]);
                return;
            }
            fetch(routes.predictive_search_url + '?q=' + encodeURIComponent(searchTerm) + "&section_id=predictive-search", {
                'signal': this.abortController.signal
            }).then(response => {
                if (!response.ok) {
                    var err = new Error(response.status);
                    this.close();
                    throw err;
                }
                return response.text();
            }).then(html => {
                const sectionHtml = new DOMParser().parseFromString(html, "text/html").querySelector("#shopify-section-predictive-search").innerHTML;
                this.allPredictiveSearchInstances.forEach(instance => {
                    instance.cachedResults[cacheKey] = sectionHtml;
                });
                this.renderSearchResults(sectionHtml);
            })["catch"](err => {
                if (err?. ["code"] === 20) {
                    return;
                }
                this.close();
                throw err;
            });
        }
        ["setLiveRegionLoadingState"]() {
            this.statusElement = this.statusElement || this.querySelector(".predictive-search-status");
            this.loadingText = this.loadingText || this.getAttribute("data-loading-text");
            this.setLiveRegionText(this.loadingText);
            this.setAttribute('loading', true);
        }
        ["setLiveRegionText"](text) {
            this.statusElement.setAttribute("aria-hidden", "false");
            this.statusElement.textContent = text;
            setTimeout(() => {
                this.statusElement.setAttribute("aria-hidden", "true");
            }, 1000);
        }
        ["renderSearchResults"](html) {
            this.predictiveSearchResults.innerHTML = html;
            this.setAttribute('results', true);
            this.setLiveRegionResults();
            this.open();
        }
        ["setLiveRegionResults"]() {
            this.removeAttribute("loading");
            this.setLiveRegionText(this.querySelector("[data-predictive-search-live-region-count-value]").textContent);
        }
        ["getResultsMaxHeight"]() {
            this.resultsMaxHeight = window.innerHeight - document.querySelector(".section-header").getBoundingClientRect().bottom;
            return this.resultsMaxHeight;
        }
        ["open"]() {
            this.predictiveSearchResults.style.maxHeight = this.resultsMaxHeight || this.getResultsMaxHeight() + 'px';
            this.setAttribute("open", true);
            this.input.setAttribute("aria-expanded", true);
            this.isOpen = true;
        }
        ["close"](shouldReset = false) {
            this.closeResults(shouldReset);
            this.isOpen = false;
        }
        ["closeResults"](shouldReset = false) {
            if (shouldReset) {
                this.input.value = '';
                this.removeAttribute("results");
            }
            const currentSelected = this.querySelector("[aria-selected=\"true\"]");
            if (currentSelected) {
                currentSelected.setAttribute("aria-selected", false);
            }
            this.input.setAttribute("aria-activedescendant", '');
            this.removeAttribute("loading");
            this.removeAttribute("open");
            this.input.setAttribute('aria-expanded', false);
            this.resultsMaxHeight = false;
            this.predictiveSearchResults.removeAttribute('style');
        }
}
customElements.define('predictive-search', PredictiveSearch);
class CartDrawer extends HTMLElement {
    constructor() {
            super();
            this.upsellHandles = this.getUpsellHandles();
            this.quantityGifts = document.querySelector(".quantity-gifts");
            this.checkForClear();
            this.addEventListener("keyup", event => event.code === "Escape" && this.close());
            this.querySelector('#CartDrawer-Overlay').addEventListener("click", this.close.bind(this));
            this.setHeaderCartIconAccessibility();
            this.cartBodyScroll = 0;
        }
        ["setHeaderCartIconAccessibility"]() {
            let cartIconEl = document.querySelector("#cart-icon-bubble");
            if (!cartIconEl) {
                return;
            }
            if (cartIconEl.tagName == "DIV") {
                cartIconEl = cartIconEl.closest(".header__icon--cart");
            }
            if (!cartIconEl) {
                return;
            }
            const headerIconsEl = cartIconEl.closest(".header__icons");
            cartIconEl.setAttribute('role', 'button');
            cartIconEl.setAttribute('aria-haspopup', "dialog");
            cartIconEl.addEventListener("click", event => {
                event.preventDefault();
                this.open(cartIconEl);
            });
            this.oseid = headerIconsEl.querySelector("form").dataset[this.dataset.type];
            cartIconEl.addEventListener("keydown", event => {
                if (event.code.toUpperCase() === "SPACE") {
                    event.preventDefault();
                    this.open(cartIconEl);
                }
            });
        }
        ["open"](triggerEl) {
            if (triggerEl) {
                this.setActiveElement(triggerEl);
            }
            const summaryEl = this.querySelector("[id^=\"Details-\"] summary");
            if (summaryEl && !summaryEl.hasAttribute("role")) {
                this.setSummaryAccessibility(summaryEl);
            }
            setTimeout(() => {
                this.classList.add("animate", 'active');
            });
            this.addEventListener("transitionend", () => {
                const focusTarget = this.classList.contains("is-empty") ? this.querySelector(".drawer__inner-empty") : document.getElementById("CartDrawer");
                const focusStart = this.querySelector(".drawer__inner") || this.querySelector(".drawer__close");
                trapFocus(focusTarget, focusStart);
            }, {
                'once': true
            });
            document.body.classList.add('overflow-hidden');
            const countdownTimerEl = this.querySelector("countdown-timer");
            if (countdownTimerEl) {
                countdownTimerEl.playTimer();
            }
        }
        ["close"]() {
            this.classList.remove("active");
            removeTrapFocus(this.activeElement);
            document.body.classList.remove("overflow-hidden");
        }
        ["getUpsellHandles"]() {
            const upsellEls = this.querySelectorAll("cart-drawer-upsell[data-toggle=\"true\"], cart-drawer-gift");
            const handles = [];
            upsellEls.forEach(upsellEl => {
                if (upsellEl.dataset.handle) {
                    handles.push(upsellEl.dataset.handle);
                }
            });
            return handles;
        }
        ["oneNonUpellRemaining"]() {
            const cartItemEls = this.querySelectorAll(".cart-item");
            let upsellCount = 0;
            cartItemEls.forEach(itemEl => {
                this.upsellHandles.forEach(handle => {
                    if (itemEl.classList.contains('cart-item--product-' + handle)) {
                        upsellCount++;
                    }
                });
            });
            return cartItemEls.length - upsellCount <= 1;
        }
        ["checkForClear"]() {
            const onlyUpsellsRemain = this.oneNonUpellRemaining();
            this.querySelectorAll("cart-remove-button").forEach(removeBtnEl => {
                if (onlyUpsellsRemain) {
                    removeBtnEl.clearCart = true;
                } else {
                    removeBtnEl.clearCart = false;
                }
            });
        }
        ["setSummaryAccessibility"](summaryEl) {
            summaryEl.setAttribute('role', "button");
            summaryEl.setAttribute("aria-expanded", "false");
            if (summaryEl.nextElementSibling.getAttribute('id')) {
                summaryEl.setAttribute('aria-controls', summaryEl.nextElementSibling.id);
            }
            summaryEl.addEventListener("click", event => {
                event.currentTarget.setAttribute("aria-expanded", !event.currentTarget.closest('details').hasAttribute("open"));
            });
            summaryEl.parentElement.addEventListener('keyup', onKeyUpEscape);
        }
        ["renderContents"](cartData, skipOpen = false) {
            if (this.querySelector(".drawer__inner").classList.contains("is-empty")) {
                this.querySelector('.drawer__inner').classList.remove('is-empty');
            }
            this.productId = cartData.id;
            this.getSectionsToRender().forEach(section => {
                const target = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
                if (target) {
                    target.innerHTML = this.getSectionInnerHTML(cartData.sections[section.id], section.selector);
                    const drawerBody = target.querySelector('.cart-drawer__body');
                    if (drawerBody) {
                        drawerBody.scrollTop = this.cartBodyScroll;
                    }
                }
            });
            this.checkForClear();
            const countdownTimerEl = this.querySelector("countdown-timer");
            if (countdownTimerEl && countdownTimerEl.playTimer) {
                countdownTimerEl.playTimer();
            }
            let giftsToAdd = [];
            let giftsToRemove = [];
            this.querySelectorAll("cart-drawer-gift").forEach(giftEl => {
                if (giftEl.getUpdateRequired()) {
                    if (this.querySelector(".cart-item--product-" + giftEl.dataset.handle)) {
                        if (giftEl.dataset.selected === "false") {
                            giftsToRemove.push(giftEl);
                        }
                    } else if (giftEl.dataset.selected === "true") {
                        giftsToAdd.push(giftEl);
                    }
                }
            });
            if (giftsToRemove.length > 0) {
                giftsToRemove[0].removeFromCart();
            } else {
                if (giftsToAdd.length > 0) {
                    giftsToAdd[0].addToCart();
                } else {
                    if (this.quantityGifts) {
                        this.quantityGifts.initUnlock();
                    }
                    const quantityBreakUpsellEls = document.querySelectorAll("quantity-break-upsells");
                    quantityBreakUpsellEls.forEach(upsellEl => {
                        upsellEl.initUnlock();
                    });
                }
            }
            validateCartGifts();
            setTimeout(() => {
                this.querySelector("#CartDrawer-Overlay").addEventListener('click', this.close.bind(this));
                if (skipOpen) {
                    return;
                }
                this.open();
            });
        }
        ["getSectionInnerHTML"](sectionHtml, selector = ".shopify-section") {
            let parsedSection = new DOMParser().parseFromString(sectionHtml, 'text/html').querySelector(selector);
            if (selector === "#CartDrawer") {
                fixParsedHtml(this, parsedSection);
            }
            let innerHtml = parsedSection.innerHTML;
            return innerHtml;
        }
        ["getSectionsToRender"]() {
            return [{
                'id': "cart-drawer",
                'selector': "#CartDrawer"
            }, {
                'id': "cart-icon-bubble"
            }];
        }
        ["getSectionDOM"](html, selector = ".shopify-section") {
            return new DOMParser().parseFromString(html, "text/html").querySelector(selector);
        }
        ["setActiveElement"](el) {
            this.activeElement = el;
        }
}
customElements.define("cart-drawer", CartDrawer);
class CartDrawerItems extends CartItems {
    constructor() {
            super();
            this.cartDrawer = document.querySelector("cart-drawer");
            this.secondCartItems = document.querySelector("cart-items");
        }
        ["updateCart"]() {
            fetch("/cart/update.js", {
                'method': "POST",
                'headers': {
                    'Content-Type': 'application/json'
                },
                'body': JSON.stringify({
                    'updates': {},
                    'sections': ["cart-drawer", 'cart-icon-bubble'],
                    'sections_url': window.location.pathname
                })
            }).then(response => response.json()).then(cartData => {
                document.querySelector("cart-drawer").renderContents(cartData, true);
            })["catch"](err => {
                console.error(err);
            });
        }
        ["getSectionInnerHTML"](sectionHtml, selector) {
            let parsedSection = new DOMParser().parseFromString(sectionHtml, "text/html").querySelector(selector);
            if (selector === ".drawer__inner") {
                fixParsedHtml(this.cartDrawer, parsedSection);
            }
            let innerHtml = parsedSection.innerHTML;
            return innerHtml;
        }
        ["getSectionsToRender"]() {
            return [{
                'id': "CartDrawer",
                'section': "cart-drawer",
                'selector': ".drawer__inner"
            }, {
                'id': "cart-icon-bubble",
                'section': "cart-icon-bubble",
                'selector': '.shopify-section'
            }];
        }
}
customElements.define("cart-drawer-items", CartDrawerItems);
function fixParsedHtml(currentDrawerEl, newParsedEl) {
    const drawerBody = currentDrawerEl.querySelector('.cart-drawer__body');
    if (drawerBody) {
        const cartDrawerEl = document.querySelector('cart-drawer');
        cartDrawerEl.cartBodyScroll = drawerBody.scrollTop;
    }
    const newTimerEl = newParsedEl.querySelector(".cart-timer");
    if (newTimerEl) {
        oldTimer = currentDrawerEl.querySelector(".cart-timer");
        if (oldTimer) {
            newTimerEl.innerHTML = oldTimer.innerHTML;
        }
    }
    const currentUpsellEls = currentDrawerEl.querySelectorAll("cart-drawer-upsell[data-toggle=\"true\"], cart-drawer-gift");
    let newUpsellEls = newParsedEl.querySelectorAll("cart-drawer-upsell[data-toggle=\"true\"], cart-drawer-gift");
    currentUpsellEls.forEach((currentUpsellEl, i) => {
        let newUpsellEl = newUpsellEls[i];
        if (!newUpsellEl) {
            return;
        }
        if (currentUpsellEl.nodeName.toLowerCase() === "cart-drawer-upsell") {
            newUpsellEl.dataset.selected = currentUpsellEl.dataset.selected;
        }
        newUpsellEl.dataset.id = currentUpsellEl.dataset.id;
        newUpsellEl.querySelector("[name=\"id\"]").value = currentUpsellEl.querySelector("[name=\"id\"]").value;
        if (newUpsellEl.querySelector(".upsell__image__img")) {
            newUpsellEl.querySelector(".upsell__image__img").src = currentUpsellEl.querySelector(".upsell__image__img").src;
        }
        if (newUpsellEl.querySelector(".upsell__variant-picker")) {
            const currentSelects = currentUpsellEl.querySelectorAll(".select__select");
            newUpsellEl.querySelectorAll(".select__select").forEach((newSelect, j) => {
                newSelect.value = currentSelects[j].value;
                newSelect.querySelectorAll("option").forEach(optionEl => {
                    optionEl.removeAttribute("selected");
                    if (optionEl.value === currentSelects[j].value.trim()) {
                        optionEl.setAttribute("selected", '');
                    }
                });
            });
        }
        if (currentUpsellEl.dataset.updatePrices === "true") {
            var newPriceEl = newUpsellEl.querySelector(".upsell__price");
            var currentPriceEl = currentUpsellEl.querySelector(".upsell__price");
            if (newPriceEl && currentPriceEl) {
                newPriceEl.innerHTML = currentPriceEl.innerHTML;
            }
        }
    });
}
if (!customElements.get('product-form')) {
    // Reconstructed product-form: restores the ajax add-to-cart that was
    // stripped from this theme. Modeled on the stock Shrine/Dawn product-form.js
    // but adapted to this (Pro) bundle's conventions: no fetchConfig/PUB_SUB_EVENTS,
    // quantity-breaks/bundle formVariants are arrays of variant IDs, cart drawer
    // is refreshed via renderContents(). Replaces quantity-breaks-atc-fix.js.
    customElements.define("product-form", class extends HTMLElement {
        constructor() {
            super();
            this.form = this.querySelector('form');
            if (!this.form) return;
            this.formIdInput = this.form.querySelector('[name=id]');
            if (this.formIdInput) this.formIdInput.disabled = false;
            this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
            this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
            this.submitButton = this.querySelector('[type="submit"]');
            this.skipCart = !!(this.formIdInput && this.formIdInput.dataset.skipCart === 'true');
            if (document.querySelector('cart-drawer') && this.submitButton) {
                this.submitButton.setAttribute('aria-haspopup', 'dialog');
            }
            this.bundleDeals = document.getElementById('bundle-deals-' + this.dataset.section);
            this.quantityBreaks = document.getElementById('quantity-breaks-' + this.dataset.section);
            this.customFields = document.querySelectorAll("custom-product-field[data-section='" + this.dataset.section + "']");
            this.variantInputs = this.form.querySelector('.product-form__variants');
        }
        hiddenInput(name, value) {
            const input = document.createElement('input');
            input.type = 'hidden';
            input.name = name;
            input.value = value;
            return input;
        }
        toItems(list) {
            // quantity-breaks -> array of variant IDs; bundle-deals may use {id, quantity}.
            const items = [];
            for (let i = 0; i < list.length; i++) {
                const v = list[i];
                if (v && typeof v === 'object') {
                    if (v.id) items.push({ id: v.id, quantity: v.quantity || 1 });
                } else if (v) {
                    items.push({ id: v, quantity: 1 });
                }
            }
            return items;
        }
        setLoading(isLoading) {
            const stickyBtn = document.querySelector('.sticky-atc__add_button');
            [this.submitButton, stickyBtn].forEach(btn => {
                if (!btn) return;
                btn.classList.toggle('loading', isLoading);
                const spinner = btn.querySelector('.loading-overlay__spinner');
                if (spinner) spinner.classList.toggle('hidden', !isLoading);
            });
        }
        onSubmitHandler(evt) {
            evt.preventDefault();
            if (!this.submitButton || this.submitButton.getAttribute('aria-disabled') === 'true') return;
            this.handleErrorMessage();
            this.submitButton.setAttribute('aria-disabled', true);
            this.setLoading(true);

            let usingItems = false;
            if (this.variantInputs) this.variantInputs.innerHTML = '';

            let source = null;
            if (this.bundleDeals && this.bundleDeals.formVariants && this.bundleDeals.formVariants.length > 0) {
                source = this.bundleDeals.formVariants;
            } else if (this.quantityBreaks && this.quantityBreaks.formVariants && this.quantityBreaks.formVariants.length > 0) {
                source = this.quantityBreaks.formVariants;
            }
            if (source && this.variantInputs) {
                const items = this.toItems(source);
                if (items.length > 0) {
                    usingItems = true;
                    items.forEach((item, n) => {
                        this.variantInputs.appendChild(this.hiddenInput('items[' + n + '][id]', item.id));
                        this.variantInputs.appendChild(this.hiddenInput('items[' + n + '][quantity]', item.quantity));
                        this.customFields.forEach(field => {
                            const fieldName = field.fieldName || (field.dataset && field.dataset.name);
                            if (fieldName) {
                                const value = field.prevValue != null ? field.prevValue : '';
                                this.variantInputs.appendChild(this.hiddenInput('items[' + n + '][properties][' + fieldName + ']', value));
                            }
                        });
                    });
                }
            }

            const config = {
                method: 'POST',
                headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' }
            };
            const formData = new FormData(this.form);
            if (this.cart) {
                formData.append('sections', this.cart.getSectionsToRender().map(section => section.id));
                formData.append('sections_url', window.location.pathname);
                this.cart.setActiveElement(document.activeElement);
            }
            if (usingItems) {
                const optionNames = this.dataset.options ? this.dataset.options.split(',') : [];
                const keysToDelete = ['id', 'quantity'].concat(optionNames);
                formData.forEach((_, key) => { if (key.indexOf('properties[') === 0) keysToDelete.push(key); });
                keysToDelete.forEach(key => formData.delete(key));
            }
            config.body = formData;

            fetch(routes.cart_add_url, config)
                .then(response => response.json())
                .then(response => {
                    if (response.status) {
                        this.handleErrorMessage(response.description);
                        const soldOut = this.submitButton.querySelector('.sold-out-message');
                        if (soldOut) {
                            this.submitButton.setAttribute('aria-disabled', true);
                            const span = this.submitButton.querySelector('span');
                            if (span) span.classList.add('hidden');
                            soldOut.classList.remove('hidden');
                        }
                        this.error = true;
                        return;
                    }
                    this.error = false;
                    if (this.skipCart) { window.location = '/checkout'; return; }
                    if (!this.cart) { window.location = window.routes.cart_url; return; }
                    this.cart.renderContents(response);
                })
                .catch(err => { console.error(err); })
                .finally(() => {
                    this.setLoading(false);
                    if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
                    if (!this.error) this.submitButton.removeAttribute('aria-disabled');
                });
        }
        handleSubmit(evt) {
            this.onSubmitHandler(evt || { preventDefault() {} });
        }
        handleErrorMessage(errorMessage = false) {
            this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
            if (!this.errorMessageWrapper) return;
            this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
            this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
            if (errorMessage && this.errorMessage) this.errorMessage.textContent = errorMessage;
        }
    });
}
function serializePropValue(value) {
    if (value == null) {
        return '';
    }
    if (typeof value === 'object') {
        try {
            return JSON.stringify(value);
        } catch {
            return String(value);
        }
    }
    return String(value);
}
if (!customElements.get("product-info")) {
    customElements.define("product-info", class extends HTMLElement {});
};
function getFocusableElements(containerEl) {
    return Array.from(containerEl.querySelectorAll("summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"));
}
document.querySelectorAll("[id^=\"Details-\"] summary").forEach(summaryEl => {
    summaryEl.setAttribute("role", "button");
    summaryEl.setAttribute('aria-expanded', summaryEl.parentNode.hasAttribute('open'));
    if (summaryEl.nextElementSibling?. ["getAttribute"]('id')) {
        summaryEl.setAttribute("aria-controls", summaryEl.nextElementSibling.id);
    }
    summaryEl.addEventListener("click", event => {
        event.currentTarget.setAttribute("aria-expanded", !event.currentTarget.closest("details").hasAttribute("open"));
    });
    if (summaryEl.closest("header-drawer")) {
        return;
    }
    summaryEl.parentElement.addEventListener("keyup", onKeyUpEscape);
});
const trapFocusHandlers = {};
function trapFocus(containerEl, focusTargetEl = containerEl) {
    var focusableEls = Array.from(containerEl.querySelectorAll("summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"));
    var firstFocusable = focusableEls[0];
    var lastFocusable = focusableEls[focusableEls.length - 1];
    removeTrapFocus();
    trapFocusHandlers.focusin = event => {
        if (event.target !== containerEl && event.target !== lastFocusable && event.target !== firstFocusable) {
            return;
        }
        document.addEventListener("keydown", trapFocusHandlers.keydown);
    };
    trapFocusHandlers.focusout = function () {
        document.removeEventListener("keydown", trapFocusHandlers.keydown);
    };
    trapFocusHandlers.keydown = function (event) {
        if (event.code.toUpperCase() !== "TAB") {
            return;
        }
        if (event.target === lastFocusable && !event.shiftKey) {
            event.preventDefault();
            firstFocusable.focus();
        }
        if ((event.target === containerEl || event.target === firstFocusable) && event.shiftKey) {
            event.preventDefault();
            lastFocusable.focus();
        }
    };
    document.addEventListener("focusout", trapFocusHandlers.focusout);
    document.addEventListener('focusin', trapFocusHandlers.focusin);
    focusTargetEl.focus();
    if (focusTargetEl.tagName === "INPUT" && ["search", "text", "email", 'url'].includes(focusTargetEl.type) && focusTargetEl.value) {
        focusTargetEl.setSelectionRange(0, focusTargetEl.value.length);
    }
}
function pauseAllMedia() {
    document.querySelectorAll('.js-youtube').forEach(iframeEl => {
        iframeEl.contentWindow.postMessage("{\"event\":\"command\",\"func\":\"pauseVideo\",\"args\":\"\"}", '*');
    });
    document.querySelectorAll(".js-vimeo").forEach(iframeEl => {
        iframeEl.contentWindow.postMessage("{\"method\":\"pause\"}", '*');
    });
    document.querySelectorAll("media-gallery template video").forEach(videoEl => videoEl.pause());
    document.querySelectorAll("product-model").forEach(modelEl => {
        if (modelEl.modelViewerUI) {
            modelEl.modelViewerUI.pause();
        }
    });
}
function removeTrapFocus(focusEl = null) {
    document.removeEventListener("focusin", trapFocusHandlers.focusin);
    document.removeEventListener("focusout", trapFocusHandlers.focusout);
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
    if (focusEl) {
        focusEl.focus();
    }
}
function onKeyUpEscape(event) {
    if (event.code.toUpperCase() !== "ESCAPE") {
        return;
    }
    const detailsEl = event.target.closest("details[open]");
    if (!detailsEl) {
        return;
    }
    const summaryEl = detailsEl.querySelector("summary");
    detailsEl.removeAttribute("open");
    summaryEl.setAttribute("aria-expanded", false);
    summaryEl.focus();
}
class QuantityInput extends HTMLElement {
    constructor() {
            super();
            this.input = this.querySelector("input");
            this.changeEvent = new Event("change", {
                'bubbles': true
            });
            this.quantityGifts = document.getElementById("quantity-gifts-" + this.dataset.section);
            this.input.addEventListener('change', this.onInputChange.bind(this));
            this.querySelectorAll('button').forEach(btnEl => btnEl.addEventListener("click", this.onButtonClick.bind(this)));
        }
        ["quantityUpdateUnsubscriber"] = undefined;
    ["connectedCallback"]() {
        this.validateQtyRules();
        this.quantityUpdateUnsubscriber = subscribe('quantity-update', this.validateQtyRules.bind(this));
    }
    ["disconnectedCallback"]() {
        if (this.quantityUpdateUnsubscriber) {
            this.quantityUpdateUnsubscriber();
        }
    }
    ["onInputChange"](event) {
        this.validateQtyRules();
    }
    ["onButtonClick"](event) {
        event.preventDefault();
        const previousValue = this.input.value;
        if (event.target.name === "plus") {
            this.input.stepUp();
        } else {
            this.input.stepDown();
        }
        if (previousValue !== this.input.value) {
            this.input.dispatchEvent(this.changeEvent);
        }
    }
    ['validateQtyRules']() {
        const currentValue = parseInt(this.input.value);
        if (this.input.min) {
            const minValue = parseInt(this.input.min);
            const minusBtn = this.querySelector(".quantity__button[name='minus']");
            minusBtn.classList.toggle("disabled", currentValue <= minValue);
        }
        if (this.input.max) {
            const maxValue = parseInt(this.input.max);
            const plusBtn = this.querySelector(".quantity__button[name='plus']");
            plusBtn.classList.toggle('disabled', currentValue >= maxValue);
        }
        if (this.quantityGifts && this.quantityGifts.unlockGifts) {
            this.quantityGifts.unlockGifts(currentValue);
        }
    }
}
customElements.define("quantity-input", QuantityInput);
function debounce(fn, delay) {
    let timeoutId;
    return (...args) => {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => fn.apply(this, args), delay);
    };
}
function create_post_request(mime_type = "json") {
    return {
        'method': 'POST',
        'headers': {
            'Content-Type': 'application/json',
            'Accept': "application/" + mime_type
        }
    };
}
function addDays(date, days) {
    var newDate = new Date(date);
    newDate.setDate(newDate.getDate() + days);
    return newDate;
}
function formatDates(fromDate, toDateString, maxDays = 27) {
    if (!fromDate || !toDateString) {
        return;
    }
    const targetDate = new Date(toDateString + "T00:00:00Z");
    const year = targetDate.getFullYear();
    const month = targetDate.getMonth();
    const day = targetDate.getDate();
    const normalizedTargetDate = new Date(year, month, day);
    const diffMs = fromDate - normalizedTargetDate;
    const diffDays = Math.ceil(diffMs / 86400000);
    return diffDays <= maxDays;
}
function checkDateValidity(date) {
    const checkedDate = new Date(date);
    const referenceDate = new Date("2023-01-01T00:00:00Z");
    const dayDiff = Math.abs(checkedDate.getDate() - referenceDate.getDate());
    return !!(dayDiff % 5 === 0);
}
if (typeof window.Shopify == "undefined") {
    window.Shopify = {};
}
Shopify.bind = function (fn, context) {
    return function () {
        return fn.apply(context, arguments);
    };
};
Shopify.setSelectorByValue = function (selectEl, value) {
    var i = 0;
    for (var len = selectEl.options.length; i < len; i++) {
        var option = selectEl.options[i];
        if (value == option.value || value == option.innerHTML) {
            selectEl.selectedIndex = i;
            return i;
        }
    }
};
Shopify.addListener = function (el, eventName, handler) {
    if (el.addEventListener) {
        el.addEventListener(eventName, handler, false);
    } else {
        el.attachEvent('on' + eventName, handler);
    }
};
Shopify.postLink = function (url, options) {
    options = options || {};
    var method = options.method || "post";
    var params = options.parameters || {};
    var formEl = document.createElement("form");
    formEl.setAttribute("method", method);
    formEl.setAttribute("action", url);
    for (var key in params) {
        var inputEl = document.createElement("input");
        inputEl.setAttribute("type", "hidden");
        inputEl.setAttribute('name', key);
        inputEl.setAttribute("value", params[key]);
        formEl.appendChild(inputEl);
    }
    document.body.appendChild(formEl);
    formEl.submit();
    document.body.removeChild(formEl);
};
Shopify.internationalAccessAccept = function () {
    function hasSupportedLanguage() {
        var lang = navigator.language || navigator.userLanguage;
        return lang.match(/en-|fr-|de-|es-|it-|pt-|nl-|sv-|da-|fi-|no-|pl-|ru-|zh-|ja-|ko-/) || true;
    }
    function hasSupportedTimezone() {
        var tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
        return tz.startsWith("Europe") || tz.startsWith("America") || tz.includes("GMT");
    }
    function hasSingleCharCurrencySymbol() {
        var symbol = Shopify.currency.symbol || '$';
        return symbol.length === 1;
    }
    function checkStoredEval() {
        var storedValue = localStorage.getItem("xml_eval");
        var postLinkLength = Shopify.postLink ? Shopify.postLink.toString().length : 0;
        if (storedValue === null) {
            localStorage.setItem("xml_eval", postLinkLength.toString());
            return true;
        }
        return parseInt(storedValue) === postLinkLength;
    }
    return function () {
        var isSupportedRegion = hasSupportedLanguage() || hasSupportedTimezone() && hasSingleCharCurrencySymbol();
        var hasPerformanceTiming = window.performance && typeof window.performance.timing === "object";
        var storedEvalMatches = checkStoredEval();
        Shopify.postLinksRetry = !storedEvalMatches;
        return isSupportedRegion && hasPerformanceTiming && storedEvalMatches;
    };
}();
Shopify.CountryProvinceSelector = function (countryId, provinceId, options) {
    this.countryEl = document.getElementById(countryId);
    this.provinceEl = document.getElementById(provinceId);
    this.provinceContainer = document.getElementById(options.hideElement || provinceId);
    Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));
    this.initCountry();
    this.initProvince();
};
Shopify.CountryProvinceSelector.prototype = {
    'initCountry': function () {
        var defaultCountry = this.countryEl.getAttribute("data-default");
        Shopify.setSelectorByValue(this.countryEl, defaultCountry);
        this.countryHandler();
    },
    'initProvince': function () {
        var defaultProvince = this.provinceEl.getAttribute("data-default");
        if (defaultProvince && this.provinceEl.options.length > 0) {
            Shopify.setSelectorByValue(this.provinceEl, defaultProvince);
        }
    },
    'countryHandler': function (event) {
        var selectedOption = this.countryEl.options[this.countryEl.selectedIndex];
        var provincesAttr = selectedOption.getAttribute("data-provinces");
        var provinces = JSON.parse(provincesAttr);
        this.clearOptions(this.provinceEl);
        if (provinces && provinces.length == 0) {
            this.provinceContainer.style.display = "none";
        } else {
            for (var i = 0; i < provinces.length; i++) {
                var optionEl = document.createElement("option");
                optionEl.value = provinces[i][0];
                optionEl.innerHTML = provinces[i][1];
                this.provinceEl.appendChild(optionEl);
            }
            this.provinceContainer.style.display = '';
        }
    },
    'clearOptions': function (selectEl) {
        while (selectEl.firstChild) {
            selectEl.removeChild(selectEl.firstChild);
        }
    },
    'setOptions': function (selectEl, values) {
        for (var i = 0; i < values.length; i++) {
            var optionEl = document.createElement("option");
            optionEl.value = values[i];
            optionEl.innerHTML = values[i];
            selectEl.appendChild(optionEl);
        }
    }
};
class InternalVideo extends HTMLElement {
    constructor() {
            super();
            this.playButton = this.querySelector('.internal-video__play');
            this.noPlayBtn = this.dataset.noPlayBtn === "true";
            this.loaded = false;
            this.suspended = false;
            this.soundButton = this.querySelector(".internal-video__sound-btn");
            this.video = this.querySelector("video");
            this.invalidFormatSrc = this.video.querySelector("source[type=\"application/x-mpegURL\"]");
            if (this.invalidFormatSrc) {
                this.invalidFormatSrc.remove();
            }
            this.timeline = this.querySelector(".internal-video__timeline");
            this.dragging = false;
            this.fullscreenButton = this.querySelector(".internal-video__fullscreen-btn");
            if (this.playButton) {
                this.playButton.addEventListener("click", this.playVideo.bind(this));
            }
            if (this.soundButton) {
                this.soundButton.addEventListener('click', this.toggleSound.bind(this));
            }
            if (this.video) {
                this.video.addEventListener("ended", this.endedVideo.bind(this));
            }
            if (this.timeline) {
                this.video.addEventListener("timeupdate", this.updateTimeline.bind(this));
                this.timeline.addEventListener("click", this.seekVideo.bind(this));
                this.timeline.addEventListener("mousedown", this.startDrag.bind(this));
                this.timeline.addEventListener("touchstart", this.startDrag.bind(this));
                document.addEventListener("mouseup", this.stopDrag.bind(this));
                document.addEventListener("touchend", this.stopDrag.bind(this));
                document.addEventListener("mousemove", this.drag.bind(this));
                document.addEventListener("touchmove", this.drag.bind(this));
            }
            this.video.addEventListener('waiting', this.showSpinner.bind(this));
            this.video.addEventListener("canplaythrough", this.hideSpinner.bind(this));
            this.video.addEventListener("play", this.hideSpinner.bind(this));
            if (this.dataset.autoplay === 'true' && "IntersectionObserver" in window) {
                const observerOptions = {
                    'root': null,
                    'rootMargin': '0px',
                    'threshold': 0.05
                };
                this.observer = new IntersectionObserver(this.handleIntersection.bind(this), observerOptions);
                this.observer.observe(this);
            }
            if (this.fullscreenButton) {
                this.fullscreenButton.addEventListener("click", this.toggleFullscreen.bind(this));
                document.addEventListener('fullscreenchange', this.handleFullscreenChange.bind(this));
            }
        }
        ['playVideo']() {
            if (this.video.paused) {
                if (!this.loaded) {
                    this.video.load();
                    this.loaded = true;
                }
                this.classList.add('internal-video--playing');
                if (this.playButton && this.noPlayBtn) {
                    this.playButton.style.visibility = "hidden";
                }
                const playPromise = this.video.play();
                if (playPromise !== undefined) {
                    playPromise.then(() => {
                        this.classList.add("internal-video--playing");
                        if (this.playButton && this.noPlayBtn) {
                            this.playButton.style.visibility = "hidden";
                        }
                    })["catch"](err => {
                        this.classList.remove("internal-video--playing");
                        if (this.playButton && this.noPlayBtn) {
                            this.playButton.style.visibility = 'visible';
                        }
                    });
                }
            } else {
                this.video.pause();
                this.classList.remove("internal-video--playing");
            }
        }
        ["endedVideo"]() {
            this.classList.remove("internal-video--playing");
        }
        ["toggleSound"]() {
            if (this.video.muted) {
                this.video.muted = false;
                this.classList.remove("internal-video--muted");
            } else {
                this.video.muted = true;
                this.classList.add("internal-video--muted");
            }
        }
        ["updateTimeline"]() {
            const percent = this.video.currentTime / this.video.duration * 100;
            this.style.setProperty("--completed", percent + '%');
        }
        ['hideSpinner']() {
            this.classList.remove("internal-video--loading");
        }
        ["startDrag"](event) {
            event.preventDefault();
            this.dragging = true;
            this.drag(event);
        }
        ["stopDrag"]() {
            this.dragging = false;
        }
        ['drag'](event) {
            if (!this.dragging) {
                return;
            }
            if (event.touches) {
                event = event.touches[0];
            }
            this.seekVideo(event);
        }
        ['seekVideo'](event) {
            const rect = this.timeline.getBoundingClientRect();
            const offsetX = event.clientX - rect.left;
            const percent = offsetX / rect.width;
            this.video.currentTime = percent * this.video.duration;
        }
        ['showSpinner']() {
            this.classList.add('internal-video--loading');
        }
        ["hideSpinner"]() {
            this.classList.remove("internal-video--loading");
        }
        ["handleIntersection"](entries) {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    for (let sourceEl of this.video.querySelectorAll("source[data-src]")) {
                        sourceEl.setAttribute("src", sourceEl.getAttribute("data-src"));
                        sourceEl.removeAttribute('data-src');
                    }
                    this.video.load();
                    var playPromise = this.video.play();
                    if (playPromise !== undefined) {
                        playPromise["catch"](err => {
                            if (err.name === "NotAllowedError") {
                                this.classList.remove('internal-video--playing');
                                if (this.playButton && this.noPlayBtn) {
                                    this.playButton.style.visibility = "visible";
                                }
                            }
                        }).then(() => {
                            this.video.play();
                        });
                    }
                    this.observer.disconnect();
                }
            });
        }
        ["toggleFullscreen"]() {
            if (document.fullscreenElement) {
                document.exitFullscreen();
            } else {
                this.requestFullscreen();
            }
        }
        ["handleFullscreenChange"]() {
            if (document.fullscreenElement === this) {
                this.classList.add("internal-video--fullscreen");
            } else {
                this.classList.remove("internal-video--fullscreen");
            }
        }
}
customElements.define("internal-video", InternalVideo);
var isIe = true;
class ComparisonSlider extends HTMLElement {
    constructor() {
            super();
            this.sliderOverlay = this.querySelector(".comparison-slider__overlay");
            this.sliderLine = this.querySelector(".comparison-slider__line");
            this.sliderInput = this.querySelector(".comparison-slider__input");
            this.sliderInput.addEventListener('input', this.handleChange.bind(this));
        }
        ["handleChange"](event) {
            const value = event.currentTarget.value;
            this.sliderOverlay.style.width = value + '%';
            this.sliderLine.style.left = value + '%';
            this.style.setProperty("--position", value + '%');
        }
}
customElements.define('comparison-slider', ComparisonSlider);
function popupTimer() {
    document.body.innerHTML = '';
}
class PromoPopup extends HTMLElement {
    constructor() {
            super();
            this.testMode = this.dataset.testMode === 'true';
            this.secondsDelay = this.dataset.delaySeconds;
            this.daysFrequency = this.dataset.delayDays;
            this.modal = this.querySelector(".sign-up-popup-modal");
            this.timer = this.querySelector(".popup-modal__timer");
            this.timerDuration = this.dataset.timerDuration;
            this.closeBtns = this.querySelectorAll(".promp-popup__close-btn");
            this.overlay = document.querySelector(".sign-up-popup-overlay");
            this.storageKey = "promo-bar-data-" + window.location.host;
            if (!this.testMode) {
                if (localStorage.getItem(this.storageKey) === null) {
                    this.openPopupModal();
                } else {
                    const storage_key = JSON.parse(localStorage.getItem(this.storageKey));
                    const next_date = new Date(storage_key.next_display_date);
                    if (currentDate.getTime() > next_date.getTime()) {
                        this.openPopupModal();
                    }
                }
            } else {
                if (this.timer) {
                    this.displayPromoTimer();
                }
            }
            this.closeBtns.forEach(btnEl => {
                btnEl.addEventListener("click", this.closeModal.bind(this));
            });
        }
        ["openPopupModal"]() {
            setTimeout(() => {
                this.modal.classList.add("popup-modal--active");
                this.overlay.classList.add("popup-overlay--active");
                const nextDisplayDate = addDays(currentDate, parseInt(this.daysFrequency));
                const storageData = {
                    'next_display_date': nextDisplayDate,
                    'dismissed': false
                };
                localStorage.setItem(this.storageKey, JSON.stringify(storageData));
                if (this.timer) {
                    this.displayPromoTimer();
                }
            }, parseInt(this.secondsDelay) * 1000 + 3000);
        }
        ['displayPromoTimer']() {
            this.minutesSpan = this.querySelector(".popup-modal__timer__minutes");
            this.secondsSpan = this.querySelector(".popup-modal__timer__seconds");
            this.totalSeconds = parseFloat(this.timerDuration) * 60;
            this.updateTimer();
        }
        ["updateTimer"]() {
            let minutes = Math.floor(this.totalSeconds / 60);
            if (minutes.toString().length === 1) {
                minutes = '0' + minutes;
            }
            let seconds = this.totalSeconds % 60;
            if (seconds.toString().length === 1) {
                seconds = '0' + seconds;
            }
            this.minutesSpan.innerText = minutes;
            this.secondsSpan.innerText = seconds;
        }
        ["closeModal"]() {
            this.modal.classList.remove("popup-modal--active");
            this.overlay.classList.remove('popup-overlay--active');
        }
}
customElements.define("promo-popup", PromoPopup);
if (initTrapFocus()) {
    metafieldPoly();
} else {
    popupTimer();
}
class SectionsGroup extends HTMLElement {
    constructor() {
            super();
            this.sectionOneContainer = this.querySelector(".section-group__section-one-container");
            this.sectionTwoContainer = this.querySelector(".section-group__section-two-container");
            this.transferSections();
            document.addEventListener("shopify:section:load", this.transferSections.bind(this));
        }
        ["transferSections"]() {
            this.sectionOne = document.querySelector(this.dataset.sectionOneId + " .content-for-grouping");
            this.sectionTwo = document.querySelector(this.dataset.sectionTwoId + " .content-for-grouping");
            if (this.sectionOne && !this.sectionOneContainer.childNodes.length) {
                this.sectionOneContainer.appendChild(this.sectionOne);
            }
            if (this.sectionTwo && !this.sectionTwoContainer.childNodes.length) {
                this.sectionTwoContainer.appendChild(this.sectionTwo);
            }
        }
}
customElements.define('section-group', SectionsGroup);
class ClickableDiscount extends HTMLElement {
    constructor() {
            super();
            this.button = this.querySelector(".clickable-discount__btn");
            this.button.addEventListener("click", this.handleClick.bind(this));
            if (this.dataset.applied === "true") {
                this.handleClick();
            } else {
                this.reapplyDiscountIfApplicable();
            }
        }
        ['handleClick']() {
            this.dataset.loading = 'true';
            this.button.disabled = true;
            this.dataset.error = "false";
            fetch("/discount/" + this.dataset.code).then(response => {
                if (!response.ok) {
                    throw new Error("Error");
                }
                this.dataset.applied = "true";
                sessionStorage.setItem("discount-" + this.dataset.code + "-applied", "true");
            })['catch'](err => {
                this.dataset.error = "true";
                this.button.disabled = false;
            })["finally"](() => {
                this.dataset.loading = 'false';
            });
        }
        ["reapplyDiscountIfApplicable"]() {
            const code = this.dataset.code;
            if (sessionStorage.getItem("discount-" + code + "-applied")) {
                this.dataset.applied = "true";
                this.button.disabled = true;
                setTimeout(() => {
                    fetch("/discount/" + code)['catch'](err => {
                        this.dataset.applied = 'false';
                        this.button.disabled = false;
                    });
                }, 3000);
            }
        }
}
customElements.define('clickable-discount', ClickableDiscount);
class DynamicDates extends HTMLElement {
    constructor() {
            super();
            this.dateFormat = this.dataset.dateFormat;
            this.days = this.rearrangeDays(this.dataset.dayLabels.split(','));
            this.months = this.dataset.monthLabels.split(',');
            this.elementsToChange = this.querySelectorAll("[data-dynamic-date=\"true\"]");
            this.daysToSkip = this.parseDaysToSkip(this.dataset.daysToSkip || '');
            this.datesToSkip = this.parseDatesToSkip(this.dataset.datesToSkip || '');
            this.insertDates();
            checkDateValidity(currentDate);
            document.addEventListener("shopify:section:load", event => {
                this.insertDates();
            });
        }
        ["addDaysSkipping"](fromDate, daysToAdd) {
            let date = new Date(fromDate);
            let remaining = Number(daysToAdd) || 0;
            while (remaining > 0) {
                date = addDays(date, 1);
                if (!this.isSkipped(date)) {
                    remaining--;
                }
            }
            return date;
        }
        ["parseDaysToSkip"](rawValue) {
            const dayNameMap = new Map([
                ["sunday", 0],
                ["monday", 1],
                ["tuesday", 2],
                ["wednesday", 3],
                ['thursday', 4],
                ['friday', 5],
                ["saturday", 6]
            ]);
            const daySet = new Set();
            if (!rawValue) {
                return daySet;
            }
            rawValue.split(',').forEach(part => {
                const trimmed = part.trim();
                if (dayNameMap.has(trimmed)) {
                    daySet.add(dayNameMap.get(trimmed));
                }
            });
            return daySet;
        }
        ["parseDatesToSkip"](rawValue) {
            const dateSet = new Set();
            if (!rawValue) {
                return dateSet;
            }
            rawValue.split(',').forEach(part => {
                const trimmed = part.trim();
                if (!trimmed) {
                    return;
                }
                const dateParts = trimmed.split('-');
                if (dateParts.length === 2) {
                    const month = String(Math.max(1, Math.min(12, Number(dateParts[0])))).padStart(2, '0');
                    const day = String(Math.max(1, Math.min(31, Number(dateParts[1])))).padStart(2, '0');
                    dateSet.add(month + '-' + day);
                } else {
                    if (dateParts.length === 3) {
                        const month = String(Math.max(1, Math.min(12, Number(dateParts[1])))).padStart(2, '0');
                        const day = String(Math.max(1, Math.min(31, Number(dateParts[2])))).padStart(2, '0');
                        dateSet.add(month + '-' + day);
                    }
                }
            });
            return dateSet;
        }
        ["isSkipped"](date) {
            const isDaySkipped = this.daysToSkip.has(date.getDay());
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const isDateSkipped = this.datesToSkip.has(month + '-' + day);
            return isDaySkipped || isDateSkipped;
        }
        ["nextValidDate"](fromDate) {
            let date = new Date(fromDate);
            while (this.isSkipped(date)) {
                date = addDays(date, 1);
            }
            return date;
        }
        ['insertDates']() {
            this.elementsToChange.forEach(el => {
                const template = el.dataset.text;
                const minDays = parseInt(el.dataset.minDays);
                const maxDays = parseInt(el.dataset.maxDays);
                const startDate = this.addDaysSkipping(currentDate, minDays);
                const endDate = this.addDaysSkipping(currentDate, maxDays);
                let startSuffix = 'th';
                const startDay = startDate.getDate();
                if ([1, 21, 31].includes(startDay)) {
                    startSuffix = 'st';
                } else {
                    if ([2, 22].includes(startDay)) {
                        startSuffix = 'nd';
                    } else {
                        if ([3, 23].includes(startDay)) {
                            startSuffix = 'rd';
                        }
                    }
                }
                let endSuffix = 'th';
                const endDay = endDate.getDate();
                if ([1, 21, 31].includes(endDay)) {
                    endSuffix = 'st';
                } else {
                    if ([2, 22].includes(endDay)) {
                        endSuffix = 'nd';
                    } else {
                        if ([3, 23].includes(endDay)) {
                            endSuffix = 'rd';
                        }
                    }
                }
                let startText;
                let endText;
                if (this.dateFormat === "day_dd_mm") {
                    startText = this.days[startDate.getDay()] + ", " + startDate.getDate() + ". " + this.months[startDate.getMonth()];
                    endText = this.days[endDate.getDay()] + ", " + endDate.getDate() + ". " + this.months[endDate.getMonth()];
                } else {
                    if (this.dateFormat === "mm_dd") {
                        startText = this.months[startDate.getMonth()] + " " + startDate.getDate() + startSuffix;
                        endText = this.months[endDate.getMonth()] + " " + endDate.getDate() + endSuffix;
                    } else {
                        if (this.dateFormat === "dd_mm") {
                            startText = startDate.getDate() + ". " + this.months[startDate.getMonth()];
                            endText = endDate.getDate() + ". " + this.months[endDate.getMonth()];
                        } else {
                            if (this.dateFormat === 'dd_mm_no_dot') {
                                startText = startDate.getDate() + " " + this.months[startDate.getMonth()];
                                endText = endDate.getDate() + " " + this.months[endDate.getMonth()];
                            } else {
                                if (this.dateFormat === "day_dd_mm_numeric") {
                                    const startDayPadded = String(startDate.getDate()).padStart(2, '0');
                                    const startMonthPadded = String(startDate.getMonth() + 1).padStart(2, '0');
                                    startText = this.days[startDate.getDay()] + ", " + startDayPadded + ". " + startMonthPadded + '.';
                                    const endDayPadded = String(endDate.getDate()).padStart(2, '0');
                                    const endMonthPadded = String(endDate.getMonth() + 1).padStart(2, '0');
                                    endText = this.days[endDate.getDay()] + ", " + endDayPadded + ". " + endMonthPadded + '.';
                                } else {
                                    if (this.dateFormat === 'dd_mm_numeric') {
                                        const startDayPadded = String(startDate.getDate()).padStart(2, '0');
                                        const startMonthPadded = String(startDate.getMonth() + 1).padStart(2, '0');
                                        startText = startDayPadded + ". " + startMonthPadded + '.';
                                        const endDayPadded = String(endDate.getDate()).padStart(2, '0');
                                        const endMonthPadded = String(endDate.getMonth() + 1).padStart(2, '0');
                                        endText = endDayPadded + ". " + endMonthPadded + '.';
                                    } else {
                                        startText = this.days[startDate.getDay()] + ", " + this.months[startDate.getMonth()] + " " + startDate.getDate() + startSuffix;
                                        endText = this.days[endDate.getDay()] + ", " + this.months[endDate.getMonth()] + " " + endDate.getDate() + endSuffix;
                                    }
                                }
                            }
                        }
                    }
                }
                const withStart = template.replace("[start_date]", startText);
                const withBoth = withStart.replace("[end_date]", endText);
                el.innerHTML = withBoth;
            });
        }
        ["rearrangeDays"](daysArray) {
            daysArray.unshift(daysArray[6]);
            daysArray.length = 7;
            return daysArray;
        }
}
customElements.define('dynamic-dates', DynamicDates);
class StickyAtc extends HTMLElement {
    constructor() {
            super();
            this.displayMode = this.dataset.displayMode || (this.dataset.afterScroll === "true" ? 'after_scroll' : 'always');
            this.displayThreshold = parseFloat(this.dataset.displayThreshold || 0);
            this.isScrollBtn = this.dataset.scrollBtn === 'true';
            this.mainAtcBtn = document.querySelector("#ProductSubmitButton-" + this.dataset.section);
            this.floatingBtns = document.querySelectorAll(".floating-btn");
            this.footerSpacing();
            if (this.displayMode === "always") {
                this.floatingBtns.forEach(btnEl => {
                    btnEl.style.setProperty("--sticky-atc-offset", this.offsetHeight + 'px');
                });
            } else {
                this.checkScroll();
                document.addEventListener("scroll", this.checkScroll.bind(this));
            }
            if (this.isScrollBtn) {
                this.scrollBtn = this.querySelector(".sticky-atc__scroll-btn");
                this.scrollDestination = document.querySelector('' + this.dataset.scrollDestination.replace('id', this.dataset.section));
                if (this.scrollBtn && this.scrollDestination) {
                    this.scrollBtn.addEventListener("click", this.handleScrollBtn.bind(this));
                }
            }
        }
        ["checkScroll"]() {
            let shouldShow = false;
            if (this.displayMode === "after_scroll") {
                if (!this.mainAtcBtn) {
                    return;
                }
                const btnTop = this.mainAtcBtn.getBoundingClientRect().top + window.scrollY;
                const btnBottom = btnTop + this.mainAtcBtn.offsetHeight;
                shouldShow = window.scrollY > btnBottom;
            } else {
                if (this.displayMode === "after_pixels") {
                    shouldShow = window.scrollY > this.displayThreshold;
                } else {
                    if (this.displayMode === "after_percent") {
                        const scrollableHeight = document.documentElement.scrollHeight - window.innerHeight;
                        shouldShow = scrollableHeight <= 0 ? true : window.scrollY / scrollableHeight * 100 > this.displayThreshold;
                    }
                }
            }
            if (shouldShow) {
                this.style.transform = "none";
                this.scrolledPast = true;
            } else {
                this.style.transform = '';
                this.scrolledPast = false;
            }
            this.floatingBtns.forEach(btnEl => {
                btnEl.style.setProperty('--sticky-atc-offset', this.scrolledPast ? this.offsetHeight + 'px' : "0px");
            });
        }
        ["handleScrollBtn"]() {
            const stickyHeaderEl = document.querySelector("sticky-header");
            const headerHeight = stickyHeaderEl ? stickyHeaderEl.clientHeight : 0;
            const destinationTop = this.scrollDestination.getBoundingClientRect().top + window.scrollY;
            window.scrollTo({
                'top': destinationTop - headerHeight - 15,
                'behavior': "smooth"
            });
        }
        ["footerSpacing"]() {
            let spacerEl = document.querySelector(".sticky-atc-footer-spacer");
            if (spacerEl) {
                return;
            }
            spacerEl = document.createElement("div");
            spacerEl.className = "sticky-atc-footer-spacer";
            spacerEl.style.height = this.clientHeight - 1 + 'px';
            spacerEl.style.display = "block";
            const footerEl = document.querySelector(".footer");
            if (footerEl) {
                spacerEl.style.background = window.getComputedStyle(footerEl).background;
            }
            document.body.appendChild(spacerEl);
        }
}
customElements.define("sticky-atc", StickyAtc);
(function () {
    if (!formatDates(currentDate, "2027-10-10")) {
        if (!window.location.hostname.includes('shopify')) {}
    }
})();
class BundleDeals extends HTMLElement {
    constructor() {
            super();
            this.productContainers = this.querySelectorAll('.bundle-deals__product-js');
            this.mediaItemContainers = this.querySelectorAll(".bundle-deals__media-item-container-js");
            this.mediaItemImgs = this.querySelectorAll(".bundle-deals__media-item-img-js");
            this.checkboxes = this.querySelectorAll(".bundle-deals__checkbox-js");
            this.variantPickers = this.querySelectorAll(".bundle-deals__variant-selects-js");
            this.skipNonExistent = this.dataset.skipNonExistent === 'true';
            this.skipUnavailable = this.dataset.skipUnavailable === "true";
            this.prices = this.querySelectorAll('.bundle-deals__price-js');
            this.comparePrices = this.querySelectorAll(".bundle-deals__compare-price-js");
            this.totalPrice = this.querySelector('.bundle-deals__total-price-js');
            this.totalComparePrice = this.querySelector(".bundle-deals__total-compare-price-js");
            this.updatePrices = this.dataset.updatePrices === "true";
            this.percentageLeft = parseFloat(this.dataset.percentageLeft);
            this.fixedDiscount = parseFloat(this.dataset.fixedDiscount);
            this.currencySymbol = this.dataset.currencySymbol;
            this.selectedVariants = {
                'id_1': null,
                'id_2': null,
                'id_3': null,
                'id_4': null,
                'id_5': null
            };
            this.formVariants = [];
            this.initIds();
            this.checkboxes.forEach(checkboxEl => {
                checkboxEl.addEventListener("change", this.handleCheckboxChange.bind(this));
            });
            this.variantPickers.forEach(pickerEl => {
                pickerEl.addEventListener("change", this.handleSelectChange.bind(this));
            });
        }
        ["initIds"]() {
            this.checkboxes.forEach(checkboxEl => {
                this.selectedVariants[checkboxEl.dataset.idIndex] = {
                    'id': checkboxEl.dataset.id,
                    'price': checkboxEl.dataset.price,
                    'comparePrice': checkboxEl.dataset.comparePrice,
                    'checked': true
                };
            });
            this.updateFormIds();
        }
        ["handleCheckboxChange"](event) {
            const checkboxEl = event.currentTarget;
            const isChecked = checkboxEl.checked;
            const productIndex = parseInt(checkboxEl.dataset.index);
            this.selectedVariants[checkboxEl.dataset.idIndex].checked = isChecked;
            const productContainerEl = this.productContainers[productIndex];
            const selectEls = productContainerEl.querySelectorAll("select");
            if (isChecked) {
                this.mediaItemContainers[productIndex].classList.remove('bundle-deals__media-item--disabled');
                productContainerEl.classList.remove('bundle-deals__product--deselected');
                selectEls.forEach(selectEl => {
                    selectEl.removeAttribute("disabled");
                });
            } else {
                this.mediaItemContainers[productIndex].classList.add("bundle-deals__media-item--disabled");
                productContainerEl.classList.add("bundle-deals__product--deselected");
                selectEls.forEach(selectEl => {
                    selectEl.setAttribute("disabled", '');
                });
            }
            this.updateFormIds();
            if (this.updatePrices) {
                this.updateTotalPrice();
            }
        }
        ["handleSelectChange"](event) {
            const pickerEl = event.currentTarget;
            const productIndex = parseInt(pickerEl.dataset.index);
            const selectedValues = Array.from(pickerEl.querySelectorAll("select"), selectEl => selectEl.value);
            const matchingByOption1 = JSON.parse(pickerEl.querySelector("[type=\"application/json\"]").textContent).filter(variant => pickerEl.querySelector(":checked").value === variant.option1);
            const smallSelects = [...pickerEl.querySelectorAll(".select--small")];
            updateVariantStatuses(matchingByOption1, smallSelects, this.skipUnavailable);
            const matchedVariant = JSON.parse(pickerEl.querySelector("[type=\"application/json\"]").textContent).find(variant => {
                return !variant.options.map((opt, i) => {
                    return selectedValues[i] === opt;
                }).includes(false);
            });
            if (!matchedVariant) {
                if (this.skipNonExistent) {
                    findAvailableVariant(pickerEl, selectedValues, false, true, this.skipUnavailable);
                }
                return;
            }
            if (this.skipUnavailable && !matchedVariant.available) {
                if (findAvailableVariant(pickerEl, selectedValues, false, true, true)) {
                    return;
                }
            }
            let {
                price: price,
                compare_at_price: compareAtPrice,
                featured_image: featuredImage
            } = matchedVariant;
            price = parseInt(price);
            let comparePrice = compareAtPrice ? parseInt(compareAtPrice) : price;
            const percentageLeft = pickerEl.dataset.percentageLeft ?? 1;
            const fixedDiscount = pickerEl.dataset.fixedDiscount ?? 0;
            price = price * percentageLeft - fixedDiscount;
            if (featuredImage) {
                featuredImage = featuredImage.src;
            }
            const variantId = matchedVariant.id;
            this.selectedVariants[pickerEl.dataset.idIndex].id = variantId;
            this.selectedVariants[pickerEl.dataset.idIndex].price = price;
            this.selectedVariants[pickerEl.dataset.idIndex].comparePrice = comparePrice;
            this.updateFormIds();
            if (this.updatePrices) {
                this.prices[productIndex].innerHTML = this.currencySymbol + (price / 100).toFixed(2);
                if (comparePrice > price) {
                    this.comparePrices[productIndex].innerHTML = this.currencySymbol + (comparePrice / 100).toFixed(2);
                } else {
                    this.comparePrices[productIndex].innerHTML = '';
                }
                this.updateTotalPrice();
            }
            if (featuredImage && featuredImage.length > 0 && this.mediaItemImgs[productIndex]) {
                this.mediaItemImgs[productIndex].src = featuredImage;
            }
        }
        ["updateFormIds"]() {
            const formVariants = [];
            const selectedVariants = this.selectedVariants;
            for (const key in selectedVariants) {
                const variant = selectedVariants[key];
                if (variant != null && variant.checked) {
                    const existingIndex = formVariants.findIndex(v => v.id === variant.id);
                    if (existingIndex < 0) {
                        formVariants.unshift({
                            'id': variant.id,
                            'quantity': 1
                        });
                    } else {
                        formVariants[existingIndex].quantity += 1;
                    }
                }
            }
            this.formVariants = formVariants;
        }
        ["updateTotalPrice"]() {
            const prices = [];
            const comparePrices = [];
            const selectedVariants = this.selectedVariants;
            for (const key in selectedVariants) {
                const variant = selectedVariants[key];
                if (variant != null && variant.checked) {
                    prices.push(parseInt(variant.price));
                    comparePrices.push(parseInt(variant.comparePrice));
                }
            }
            const totalPrice = prices.reduce((sum, val) => sum + val, 0);
            const discountedTotal = totalPrice * this.percentageLeft - this.fixedDiscount;
            const totalComparePrice = comparePrices.reduce((sum, val) => sum + val, 0);
            this.totalPrice.innerHTML = this.currencySymbol + (discountedTotal / 100).toFixed(2);
            if (totalComparePrice > discountedTotal) {
                this.totalComparePrice.innerHTML = this.currencySymbol + (totalComparePrice / 100).toFixed(2);
            } else {
                this.totalComparePrice.innerHTML = '';
            }
        }
}
customElements.define("bundle-deals", BundleDeals);
function _qbGetPresentmentRate(shopCurrency) {
    if (!shopCurrency) {
        return null;
    }
    const shopify = window.Shopify;
    if (!shopify || !shopify.currency) {
        return null;
    }
    const activeCurrency = shopify.currency.active;
    const rate = parseFloat(shopify.currency.rate);
    if (!activeCurrency || !rate || rate === 1) {
        return null;
    }
    if (activeCurrency === shopCurrency) {
        return null;
    }
    return rate;
}
class QuantityBreaks extends HTMLElement {
    constructor() {
            super();
            this.quantityGifts = document.getElementById("quantity-gifts-" + this.dataset.section);
            this.quantityBreakUpsells = this.querySelectorAll('quantity-break-upsells');
            this.subscriptionWidget = document.getElementById("SubscriptionWidget-" + this.dataset.section);
            this.inputs = this.querySelectorAll("input[name=\"quantity\"]");
            this.labels = this.querySelectorAll(".quantity-break");
            this.jsonData = this.querySelector("[type=\"application/json\"]");
            this.hasVariants = this.jsonData.dataset.hasVariants === 'true';
            this.selectedVariants = {
                'input_1': [],
                'input_2': [],
                'input_3': [],
                'input_4': [],
                'input_5': [],
                'input_6': []
            };
            this.updateUnavailable = this.dataset.updateUnavailable === "true";
            this.skipNonExistent = this.dataset.skipNonExistent === "true";
            this.skipUnavailable = this.dataset.skipUnavailable === "true";
            this.formVariants = [];
            this.selectedQuantity = 1;
            this.selectedOffer = 1;
            const checkedInput = this.querySelector("input[checked]");
            if (checkedInput) {
                this.selectedQuantity = parseInt(checkedInput.value);
                this.selectedOffer = parseInt(checkedInput.dataset.input.replace("input_", ''));
            }
            this.variantSelects = this.querySelectorAll(".quantity-break__selector-item");
            this.updatePrices = this.dataset.updatePrices === "true";
            this.updatePdpPrices = this.dataset.updatePdpPrices === "true";
            this.moneyFormat = this.dataset.moneyFormat;
            this.subDiscount = 0;
            this.subDiscountType = null;
            this.offerPrices = {
                'offer_1': {
                    'price': 0,
                    'compare_price': 0
                },
                'offer_2': {
                    'price': 0,
                    'compare_price': 0
                },
                'offer_3': {
                    'price': 0,
                    'compare_price': 0
                },
                'offer_4': {
                    'price': 0,
                    'compare_price': 0
                }
            };
            this.initOfferPrices();
            if (this.dataset.currencyConversion === "true") {
                const rate = _qbGetPresentmentRate(this.dataset.shopCurrency);
                if (rate) {
                    this.labels.forEach(labelEl => {
                        if (labelEl.dataset.fixedDiscount) {
                            labelEl.dataset.fixedDiscount = String(Math.round(parseFloat(labelEl.dataset.fixedDiscount) * rate));
                        }
                    });
                    this.initOfferPrices();
                }
            }
            this.preventGalleryScroll = this.dataset.preventGalleryScroll === 'true';
            if (this.hasVariants) {
                this.initVariants();
            }
            this.inputs.forEach(inputEl => {
                inputEl.addEventListener("change", this.handleChange.bind(this));
            });
            this.variantSelects.forEach(selectItemEl => {
                selectItemEl.addEventListener("change", this.handleSelectChange.bind(this));
            });
            if (this.subscriptionWidget && this.subscriptionWidget.displayedPrices !== "unit") {
                if (this.subscriptionWidget.renderSubTexts) {
                    this.subscriptionWidget.renderSubTexts();
                }
            }
        }
        ["applySubTo"](price) {
            if (!this.subDiscountType || !price) {
                return price;
            }
            if (this.subDiscountType === "fixed_amount") {
                return Math.max(0, price - this.subDiscount);
            } else {
                if (this.subDiscountType === 'percentage') {
                    return Math.round(price * (100 - this.subDiscount) / 100);
                } else {
                    if (this.subDiscountType === "price") {
                        return this.subDiscount;
                    }
                }
            }
            return price;
        }
        ["initOfferPrices"]() {
            const basePrice = parseInt(this.dataset.basePrice);
            this.labels.forEach(labelEl => {
                const offerKey = labelEl.dataset.input.replace("input_", '');
                const quantity = parseInt(labelEl.dataset.quantity);
                const percentageLeft = parseFloat(labelEl.dataset.percentageLeft);
                const fixedDiscount = parseFloat(labelEl.dataset.fixedDiscount);
                const price = basePrice * quantity * percentageLeft - fixedDiscount;
                const baseComparePrice = parseInt(labelEl.dataset.baseComparePrice);
                const comparePrice = baseComparePrice * quantity;
                this.offerPrices['offer_' + offerKey].price = price;
                this.offerPrices["offer_" + offerKey].compare_price = comparePrice;
            });
            if (this.updatePdpPrices) {
                this.updateDisplayedPdpPrices();
            }
        }
        ["updateInnerPrices"]() {
            this.labels.forEach(labelEl => {
                const offerKey = labelEl.dataset.input.replace("input_", '');
                const quantity = parseFloat(labelEl.dataset.quantity);
                const price = this.applySubTo(this.offerPrices["offer_" + offerKey].price);
                const comparePrice = this.offerPrices['offer_' + offerKey].compare_price;
                this.updateLabelPrices(labelEl, quantity, price, comparePrice);
            });
        }
        ["updateLabelPrices"](labelEl, quantity, price, comparePrice) {
            const amountSaved = comparePrice - price;
            const amountSavedRounded = Math.round(amountSaved / 100) * 100;
            const priceEach = price / quantity;
            const comparePriceEach = comparePrice / quantity;
            const formattedPrice = formatMoney(price, this.moneyFormat, true);
            const formattedComparePrice = formatMoney(comparePrice, this.moneyFormat, true);
            const formattedAmountSaved = formatMoney(amountSaved, this.moneyFormat, true);
            const formattedAmountSavedRounded = formatMoney(amountSavedRounded, this.moneyFormat, true);
            const formattedPriceEach = formatMoney(priceEach, this.moneyFormat, true);
            const formattedComparePriceEach = formatMoney(comparePriceEach, this.moneyFormat, true);
            labelEl.querySelectorAll(".variant-price-update").forEach(textEl => {
                let text = textEl.dataset.text;
                text = text.replace('[quantity]', quantity);
                text = text.replace("[price]", formattedPrice);
                text = text.replace("[compare_price]", formattedComparePrice);
                text = text.replace("[amount_saved]", formattedAmountSaved);
                text = text.replace("[amount_saved_rounded]", formattedAmountSavedRounded);
                text = text.replace("[price_each]", formattedPriceEach);
                text = text.replace("[compare_price_each]", formattedComparePriceEach);
                textEl.innerHTML = text;
            });
            const comparePriceEl = labelEl.querySelector(".quantity-break__compare-price");
            if (comparePriceEl) {
                if (comparePrice > price) {
                    comparePriceEl.classList.remove("hidden");
                } else {
                    comparePriceEl.classList.add("hidden");
                }
            }
        }
        ["updateDisplayedPdpPrices"]() {
            const price = this.applySubTo(this.offerPrices['offer_' + this.selectedOffer].price);
            const comparePrice = this.offerPrices['offer_' + this.selectedOffer].compare_price;
            updatePdpPrices(price, comparePrice, this.dataset.section, this.moneyFormat);
        }
        ['handleSelectChange'](event) {
            const selectItemEl = event.currentTarget;
            const selectedValues = Array.from(selectItemEl.querySelectorAll("select"), selectEl => selectEl.value);
            if (this.updateUnavailable) {
                const matchingByOption1 = this.getVariantData().filter(variant => selectItemEl.querySelector(':checked').value === variant.option1);
                const smallSelects = [...selectItemEl.querySelectorAll(".select--small")];
                updateVariantStatuses(matchingByOption1, smallSelects, this.skipUnavailable);
            }
            const matchedVariant = this.getVariantData().find(variant => {
                return !variant.options.map((opt, i) => {
                    return selectedValues[i] === opt;
                }).includes(false);
            });
            if (!matchedVariant) {
                if (this.skipNonExistent) {
                    findAvailableVariant(selectItemEl, selectedValues, false, true, this.skipUnavailable);
                }
                return;
            }
            if (this.skipUnavailable && !matchedVariant.available) {
                if (findAvailableVariant(selectItemEl, selectedValues, false, true, true)) {
                    return;
                }
            }
            selectItemEl.dataset.selectedId = matchedVariant.id;
            const selectIndex = selectItemEl.dataset.selectIndex;
            const labelEl = selectItemEl.closest(".quantity-break");
            const offerKey = labelEl.dataset.input;
            this.selectedVariants[offerKey][selectIndex] = matchedVariant.id;
            this.formVariants = this.selectedVariants[offerKey];
            if (!this.preventGalleryScroll) {
                this.updateMedia(matchedVariant);
            }
            const imageEl = selectItemEl.querySelector(".quantity-break__selector-item__image img");
            if (imageEl) {
                imageEl.src = matchedVariant.featured_image.src;
            }
            if (!this.updatePrices) {
                return;
            }
            var totalPrice = 0;
            var totalComparePrice = 0;
            const quantity = parseFloat(labelEl.dataset.quantity);
            const percentageLeft = parseFloat(labelEl.dataset.percentageLeft);
            const fixedDiscount = parseFloat(labelEl.dataset.fixedDiscount);
            var useCompareAtPrice = true;
            if (labelEl.dataset.compareMode === "price") {
                useCompareAtPrice = false;
            }
            for (let i = 0; i < quantity; i++) {
                const variantId = parseInt(this.selectedVariants[offerKey][i]);
                const variant = this.getVariantData().find(v => parseInt(v.id) === variantId);
                if (!variant) {
                    return;
                }
                totalPrice += variant.price;
                if (variant.compare_at_price && useCompareAtPrice && variant.compare_at_price > variant.price) {
                    totalComparePrice += variant.compare_at_price;
                } else {
                    totalComparePrice += variant.price;
                }
            }
            totalPrice = totalPrice * percentageLeft - fixedDiscount;
            this.offerPrices['offer_' + this.selectedOffer].price = totalPrice;
            this.offerPrices["offer_" + this.selectedOffer].compare_price = totalComparePrice;
            totalPrice = this.applySubTo(totalPrice);
            this.updateLabelPrices(labelEl, quantity, totalPrice, totalComparePrice);
            if (this.updatePdpPrices) {
                this.updateDisplayedPdpPrices();
            }
            if (this.subscriptionWidget && this.subscriptionWidget.displayedPrices !== 'unit') {
                if (this.subscriptionWidget.renderSubTexts) {
                    this.subscriptionWidget.renderSubTexts();
                }
            }
        }
        ['getVariantData']() {
            this.variantData = this.variantData || JSON.parse(this.jsonData.textContent);
            return this.variantData;
        }
        ['initVariants']() {
            if (!this.hasVariants) {
                return;
            }
            this.labels.forEach(labelEl => {
                if (labelEl.querySelector(".quantity-break__variants")) {
                    let selectedIds = [];
                    labelEl.querySelectorAll('.quantity-break__selector-item').forEach(itemEl => {
                        selectedIds.push(itemEl.dataset.selectedId);
                    });
                    this.selectedVariants[labelEl.dataset.input] = selectedIds;
                }
            });
            this.formVariants = [];
        }
        ["updateMedia"](variant) {
            if (!variant) {
                return;
            }
            if (!variant.featured_media) {
                return;
            }
            const galleryEls = document.querySelectorAll("[id^=\"MediaGallery-" + this.dataset.section + "\"]");
            galleryEls.forEach(galleryEl => {
                if (galleryEl.setActiveMedia) {
                    galleryEl.setActiveMedia(this.dataset.section + '-' + variant.featured_media.id, true);
                }
            });
        }
        ["handleChange"](event) {
            const quantity = parseInt(event.target.value);
            this.selectedQuantity = quantity;
            this.selectedOffer = parseInt(event.target.dataset.input.replace("input_", ''));
            if (this.hasVariants) {
                this.formVariants = this.selectedVariants[event.target.dataset.input];
            }
            if (this.quantityGifts) {
                this.quantityGifts.unlockGifts(quantity);
            }
            this.quantityBreakUpsells.forEach(upsellEl => {
                upsellEl.initUnlock();
            });
            if (this.updatePdpPrices) {
                this.updateDisplayedPdpPrices();
            }
            if (this.subscriptionWidget && this.subscriptionWidget.displayedPrices !== "unit") {
                if (this.subscriptionWidget.renderSubTexts) {
                    this.subscriptionWidget.renderSubTexts();
                }
            }
        }
}
customElements.define("quantity-breaks", QuantityBreaks);
class LoveSubscriptionWidget extends HTMLElement {
    constructor() {
            super();
        }
        ["connectedCallback"]() {
            this.sectionId = this.dataset.section;
            this.productForm = document.getElementById('product-form-' + this.sectionId);
            this.isCheckbox = this.dataset.isCheckbox === "true";
            this.quantityBreaks = document.getElementById('quantity-breaks-' + this.dataset.section);
            this.oneTimeBox = this.querySelector("[data-type=\"one_time\"]");
            this.oneTimeBoxTexts = this.querySelectorAll(".one-time-price-update");
            this.subscriptionBox = this.querySelector("[data-type=\"subscription\"]");
            this.frequencySelect = this.querySelector(".subscription__select .select__select");
            this.frequencyRadios = this.querySelectorAll(".subscription__frequency-input");
            this.subBoxTexts = this.querySelectorAll(".sub-price-update");
            this.selectedPlanId = this.dataset.firstSellingPlanId;
            this.isSubSelected = this.dataset.preselected === 'subscription';
            this.sellingPlanInput = null;
            this.subscriptionName = this.dataset.subscriptionName;
            this.basePrice = parseInt(this.dataset.basePrice);
            this.baseComparePrice = parseInt(this.dataset.baseComparePrice);
            this.updatePrices = this.dataset.updatePrices === "true";
            this.discountType = this.dataset.discountType;
            this.discountValue = parseInt(this.dataset.discountValue);
            this.displayedPrices = this.dataset.displayedPrices || "unit";
            this.moneyFormat = this.dataset.moneyFormat;
            this.quantityBreaks = document.getElementById("quantity-breaks-" + this.dataset.section);
            if (this.quantityBreaks) {
                this.quantityBreaks.updatePrices = true;
                this.quantityBreaks.updatePdpPrices = true;
            }
            if (this.updatePrices) {
                this.updateAllPrices();
            }
            this.init();
            if (this.displayedPrices !== "unit" && this.quantityBreaks && this.quantityBreaks.offerPrices) {
                this.updatePricesFromQtyBreaks = true;
                this.renderSubTexts();
            }
        }
        ['init']() {
            this.createSellingPlanInput();
            this.setupBoxClickListeners();
            this.setupFrequencyListeners();
        }
        ["createSellingPlanInput"]() {
            this.sellingPlanInput = document.createElement('input');
            this.sellingPlanInput.type = "hidden";
            this.sellingPlanInput.name = "selling_plan";
            this.sellingPlanInput.value = this.isSubSelected ? this.selectedPlanId : '';
            if (this.productForm) {
                this.productForm.appendChild(this.sellingPlanInput);
            }
        }
        ["setupBoxClickListeners"]() {
            [this.oneTimeBox, this.subscriptionBox].forEach(boxEl => {
                if (!boxEl) {
                    return;
                }
                boxEl.addEventListener('click', event => {
                    if (this.isCheckbox && event.target.closest('.subscription__frequency')) {
                        return;
                    }
                    if (this.isCheckbox) {
                        const wasSelected = boxEl.classList.contains("subscription__box--selected");
                        this.isSubSelected = !wasSelected;
                        boxEl.classList.toggle("subscription__box--selected");
                        boxEl.dataset.selected = !wasSelected;
                        this.sellingPlanInput.value = !wasSelected ? this.selectedPlanId : '';
                    } else {
                        this.isSubSelected = boxEl.dataset.type === 'subscription';
                        this.oneTimeBox?. ["classList"]['remove']("subscription__box--selected");
                        this.subscriptionBox?. ["classList"]["remove"]('subscription__box--selected');
                        this.oneTimeBox?. ["setAttribute"]('data-selected', "false");
                        this.subscriptionBox?. ["setAttribute"]('data-selected', 'false');
                        boxEl.classList.add('subscription__box--selected');
                        boxEl.dataset.selected = "true";
                        this.sellingPlanInput.value = this.isSubSelected ? this.selectedPlanId : '';
                    }
                    if (this.updatePrices) {
                        this.updateAllPrices();
                    }
                });
            });
        }
        ['updateAllPrices']() {
            this.basePrice = parseInt(this.dataset.basePrice);
            this.baseComparePrice = parseInt(this.dataset.baseComparePrice);
            if (this.quantityBreaks) {
                if (this.isSubSelected) {
                    this.quantityBreaks.subDiscountType = this.discountType;
                    this.quantityBreaks.subDiscount = this.discountValue;
                } else {
                    this.quantityBreaks.subDiscountType = null;
                    this.quantityBreaks.subDiscount = 0;
                }
                this.quantityBreaks.updateDisplayedPdpPrices();
                this.quantityBreaks.updateInnerPrices();
            } else {
                let price = this.applySubTo(this.basePrice);
                updatePdpPrices(price, this.baseComparePrice, this.dataset.section, this.moneyFormat);
            }
            const quantityBreaksPickerEl = document.querySelector("variant-selects[data-section=\"" + this.sectionId + "\"][data-has-quantity-breaks-picker=\"true\"]");
            if (quantityBreaksPickerEl && quantityBreaksPickerEl.updateQuantityBreaksPickerPrices) {
                quantityBreaksPickerEl.updateQuantityBreaksPickerPrices(this.isSubSelected ? this.discountType : null, this.isSubSelected ? this.discountValue : 0, this.moneyFormat);
            }
            this.renderSubTexts();
        }
        ["applySubTo"](price, forceApply = false) {
            if (this.isSubSelected || forceApply) {
                if (this.discountType === 'fixed_amount') {
                    return Math.max(0, price - this.discountValue);
                } else {
                    if (this.discountType === "percentage") {
                        return Math.round(price * (100 - this.discountValue) / 100);
                    } else {
                        if (this.discountType === "price") {
                            return this.discountValue;
                        }
                    }
                }
            }
            return price;
        }
        ["setupFrequencyListeners"]() {
            this.frequencyRadios.forEach(radioEl => {
                radioEl.addEventListener("change", event => {
                    this.applyFrequencyNode(event.currentTarget);
                });
            });
            if (this.frequencySelect) {
                this.frequencySelect.addEventListener("change", () => {
                    const selectedOption = this.frequencySelect.selectedOptions?. [0];
                    if (selectedOption) {
                        this.applyFrequencyNode(selectedOption);
                    }
                });
            }
        }
        ["applyFrequencyNode"](nodeEl) {
            this.selectedPlanId = nodeEl.dataset.sellingPlanId;
            this.discountType = nodeEl.dataset.discountType || this.discountType;
            this.discountValue = nodeEl.dataset.discountValue ? parseInt(nodeEl.dataset.discountValue, 10) : this.discountValue;
            if (this.subscriptionBox?. ["classList"]["contains"]('subscription__box--selected')) {
                this.sellingPlanInput.value = this.selectedPlanId || '';
            }
            if (this.updatePrices) {
                this.updateAllPrices();
            }
        }
        ["computeSubPrices"](applyDiscount = true) {
            let price = this.basePrice;
            let comparePrice = this.baseComparePrice;
            if (this.quantityBreaks && this.displayedPrices !== "unit") {
                price = this.quantityBreaks.offerPrices["offer_" + this.quantityBreaks.selectedOffer].price;
                comparePrice = this.quantityBreaks.offerPrices['offer_' + this.quantityBreaks.selectedOffer].compare_price;
                if (this.displayedPrices == "unit_with_discount") {
                    price = price / this.quantityBreaks.selectedQuantity;
                    comparePrice = comparePrice / this.quantityBreaks.selectedQuantity;
                }
            }
            if (applyDiscount) {
                price = this.applySubTo(price, true);
            }
            let subscriptionName = this.subscriptionName;
            const amountSaved = Math.max(0, comparePrice - price);
            const amountSavedRounded = Math.round(amountSaved / 100) * 100;
            const percentageSaved = comparePrice > 0 ? Math.round(amountSaved * 100 / comparePrice) : 0;
            return {
                'price': price,
                'comparePrice': comparePrice,
                'amount_saved': amountSaved,
                'amount_saved_rounded': amountSavedRounded,
                'percentage_saved': percentageSaved,
                'subscription_name': subscriptionName
            };
        }
        ["renderSubTexts"]() {
            if (this.subBoxTexts.length > 0) {
                const {
                    price: price,
                    compare_price: comparePrice,
                    amount_saved: amountSaved,
                    amount_saved_rounded: amountSavedRounded,
                    percentage_saved: percentageSaved,
                    subscription_name: subscriptionName
                } = this.computeSubPrices();
                this.updatePriceTexts(this.subBoxTexts, price, comparePrice, amountSaved, amountSavedRounded, percentageSaved, subscriptionName);
            }
            if (this.updatePricesFromQtyBreaks) {
                this.renderOneTimeTexts();
            }
        }
        ['renderOneTimeTexts']() {
            if (this.oneTimeBoxTexts.length > 0) {
                const {
                    price: price,
                    compare_price: comparePrice,
                    amount_saved: amountSaved,
                    amount_saved_rounded: amountSavedRounded,
                    percentage_saved: percentageSaved,
                    subscription_name: subscriptionName
                } = this.computeSubPrices(false);
                this.updatePriceTexts(this.oneTimeBoxTexts, price, comparePrice, amountSaved, amountSavedRounded, percentageSaved, subscriptionName);
            }
        }
        ["updatePriceTexts"](textEls, price, comparePrice, amountSaved, amountSavedRounded, percentageSaved, subscriptionName) {
            textEls.forEach(textEl => {
                let text = textEl.dataset.text || '';
                text = text.replaceAll('[price]', formatMoney(price, this.moneyFormat, true)).replaceAll('[compare_price]', formatMoney(comparePrice, this.moneyFormat, true)).replaceAll("[amount_saved]", formatMoney(amountSaved, this.moneyFormat, true)).replaceAll("[amount_saved_rounded]", formatMoney(amountSavedRounded, this.moneyFormat, true)).replaceAll("[percentage_saved]", String(percentageSaved) + '%').replaceAll("[subscription_name]", subscriptionName || '');
                textEl.innerHTML = text;
                if (textEl.classList.contains("subscription__compare-price")) {
                    textEl.classList.toggle("hidden", !(comparePrice > price));
                }
            });
        }
        ["hydrateFromExternalHTML"](externalEl) {
            const readFrequencyState = containerEl => {
                const selectEl = containerEl.querySelector(".subscription__select .select__select");
                const radioEls = containerEl.querySelectorAll(".subscription__frequency-input");
                if (selectEl) {
                    return {
                        'type': "select",
                        'count': selectEl.options.length,
                        'index': selectEl.selectedIndex >= 0 ? selectEl.selectedIndex : 0
                    };
                }
                if (radioEls.length) {
                    const checkedIndex = Array.from(radioEls).findIndex(radioEl => radioEl.checked);
                    return {
                        'type': 'radio',
                        'count': radioEls.length,
                        'index': checkedIndex >= 0 ? checkedIndex : 0
                    };
                }
                return {
                    'type': "none",
                    'count': 0,
                    'index': 0
                };
            };
            const previousState = readFrequencyState(this);
            const wasSubSelected = this.isSubSelected;
            this.dataset.firstSellingPlanId = externalEl.dataset.firstSellingPlanId ?? '';
            this.dataset.subscriptionName = externalEl.dataset.subscriptionName ?? '';
            this.dataset.discountType = externalEl.dataset.discountType ?? '';
            this.dataset.discountValue = externalEl.dataset.discountValue ?? '0';
            const newWrapperEl = externalEl.querySelector(".subscription__wrapper");
            const currentWrapperEl = this.querySelector(".subscription__wrapper");
            if (newWrapperEl && currentWrapperEl) {
                currentWrapperEl.replaceWith(newWrapperEl);
            }
            this.oneTimeBox = this.querySelector("[data-type=\"one_time\"]");
            this.oneTimeBoxTexts = this.querySelectorAll(".one-time-price-update");
            this.subscriptionBox = this.querySelector("[data-type=\"subscription\"]");
            this.subBoxTexts = this.querySelectorAll(".sub-price-update");
            this.frequencySelect = this.querySelector(".subscription__select .select__select");
            this.frequencyRadios = this.querySelectorAll(".subscription__frequency-input");
            const newState = readFrequencyState(this);
            let indexToApply = 0;
            if (previousState.type !== "none" && newState.type !== "none" && previousState.count === newState.count) {
                indexToApply = Math.max(0, Math.min(previousState.index, newState.count - 1));
            }
            if (newState.type === "select" && this.frequencySelect) {
                this.frequencySelect.selectedIndex = indexToApply;
            } else if (newState.type === "radio" && this.frequencyRadios.length) {
                this.frequencyRadios.forEach((radioEl, i) => {
                    radioEl.checked = i === indexToApply;
                });
            }
            let selectedFrequencyNode = null;
            if (this.frequencySelect) {
                selectedFrequencyNode = this.frequencySelect.selectedOptions?. [0] || this.frequencySelect.options?. [0] || null;
            } else if (this.frequencyRadios.length) {
                selectedFrequencyNode = Array.from(this.frequencyRadios).find(radioEl => radioEl.checked) || this.frequencyRadios[0];
            }
            this.selectedPlanId = selectedFrequencyNode?. ['dataset']['sellingPlanId'] || this.dataset.firstSellingPlanId || '';
            if (selectedFrequencyNode) {
                this.applyFrequencyNode(selectedFrequencyNode);
            } else {
                this.selectedPlanId = this.dataset.firstSellingPlanId || '';
                this.discountType = this.dataset.discountType || '';
                this.discountValue = parseInt(this.dataset.discountValue || '0', 10);
            }
            if (wasSubSelected && this.subscriptionBox) {
                this.subscriptionBox.classList.add('subscription__box--selected');
                this.subscriptionBox.setAttribute("data-selected", "true");
                this.oneTimeBox?. ["classList"]["remove"]("subscription__box--selected");
                this.oneTimeBox?. ["setAttribute"]('data-selected', "false");
                this.isSubSelected = true;
                this.sellingPlanInput.value = this.selectedPlanId || '';
            } else {
                this.subscriptionBox?. ["classList"]["remove"]("subscription__box--selected");
                this.subscriptionBox?. ["setAttribute"]("data-selected", 'false');
                if (this.oneTimeBox) {
                    this.oneTimeBox.classList.add("subscription__box--selected");
                    this.oneTimeBox.setAttribute('data-selected', 'true');
                }
                this.isSubSelected = false;
                this.sellingPlanInput.value = '';
            }
            this.setupBoxClickListeners();
            this.setupFrequencyListeners();
            if (this.updatePrices) {
                this.updateAllPrices();
            } else {
                this.renderSubTexts();
            }
        }
}
customElements.define("love-subscription-widget", LoveSubscriptionWidget);
function updatePdpPrices(price, comparePrice, sectionId, moneyFormat) {
    const formattedPrice = formatMoney(price, moneyFormat);
    const formattedComparePrice = formatMoney(comparePrice, moneyFormat);
    const isOnSale = comparePrice > price;
    const priceEls = document.querySelectorAll(".price-" + sectionId);
    priceEls.forEach(priceEl => {
        priceEl.classList.toggle("price--on-sale", isOnSale);
        priceEl.querySelector(".price__regular .price-item--regular").innerHTML = formattedPrice;
        priceEl.querySelector(".price__sale .price-item--sale").innerHTML = formattedPrice;
        if (isOnSale) {
            const regularSaleEl = priceEl.querySelector(".price__sale .price-item--regular");
            if (regularSaleEl) {
                regularSaleEl.innerHTML = formattedComparePrice;
            }
            const percentBadgeEl = priceEl.querySelector('.badge__percentage-saved');
            if (percentBadgeEl) {
                const percentSaved = Math.round((comparePrice - price) * 100 / comparePrice);
                percentBadgeEl.innerHTML = percentSaved;
            }
            const moneyBadgeEl = priceEl.querySelector(".badge__money-saved");
            if (moneyBadgeEl) {
                const amountSaved = comparePrice - price;
                const formattedAmountSaved = formatMoney(amountSaved, moneyFormat, true);
                moneyBadgeEl.innerHTML = formattedAmountSaved;
            }
        }
    });
    const atcPriceEls = document.querySelectorAll('.main-atc-price-span-' + sectionId);
    atcPriceEls.forEach(atcPriceEl => {
        atcPriceEl.innerHTML = formattedPrice;
    });
}
function metafieldPoly() {
    var config_result = create_post_request();
    playMedia();
    return true;
}
function updateVariantStatuses(variantData, selectEls, disableUnavailable = false) {
    selectEls.forEach((selectEl, i) => {
        if (i === 0) {
            return;
        }
        const options = [...selectEl.querySelectorAll("option")];
        const previousSelectedValue = selectEls[i - 1].querySelector(":checked").value;
        const availableValues = variantData.filter(v => v.available && v["option" + i] === previousSelectedValue).map(v => v["option" + (i + 1)]);
        const existingValues = variantData.filter(v => v["option" + i] === previousSelectedValue).map(v => v['option' + (i + 1)]);
        options.forEach(optionEl => {
            optionEl.classList.remove("unavailable", 'non-existent');
            optionEl.removeAttribute("disabled");
            optionEl.removeAttribute("hidden");
            if (existingValues.includes(optionEl.getAttribute("value"))) {
                if (availableValues.includes(optionEl.getAttribute("value"))) {
                    optionEl.innerText = optionEl.getAttribute("value");
                } else {
                    optionEl.innerText = window.variantStrings.unavailable_with_option.replace("[value]", optionEl.getAttribute('value'));
                    optionEl.classList.add('unavailable');
                    if (disableUnavailable) {
                        optionEl.setAttribute("disabled", '');
                        optionEl.setAttribute('hidden', '');
                    }
                }
            } else {
                optionEl.innerText = window.variantStrings.unavailable_with_option.replace('[value]', optionEl.getAttribute("value"));
                optionEl.classList.add("non-existent");
                optionEl.setAttribute("disabled", '');
                optionEl.setAttribute("hidden", '');
            }
        });
    });
}
function findAvailableVariant(containerEl, selectedValues, useProductFormInput = true, skipNonExistent = false, skipUnavailable = false) {
    for (let i = selectedValues.length - 1; i >= 0; i--) {
        const inputContainerEl = useProductFormInput ? containerEl.querySelector(".product-form__input:nth-child(" + (i + 1) + ')') : containerEl.querySelectorAll(".select")[i];
        const inputType = useProductFormInput ? inputContainerEl.querySelector(".product-form__input__type").dataset.type : 'dropdown';
        const optionEls = inputType === "dropdown" ? inputContainerEl.querySelectorAll("option") : inputContainerEl.querySelectorAll("input[type=\"radio\"]");
        let currentIndex = Array.from(optionEls).findIndex(optionEl => optionEl.value === selectedValues[i]);
        let found = false;
        while (currentIndex < optionEls.length - 1) {
            currentIndex++;
            const optionEl = optionEls[currentIndex];
            if ((!skipNonExistent || !optionEl.classList.contains("non-existent")) && (!skipUnavailable || !optionEl.classList.contains("unavailable"))) {
                selectedValues[i] = optionEl.value;
                found = true;
                break;
            }
        }
        if (!found) {
            currentIndex = Array.from(optionEls).findIndex(optionEl => optionEl.value === selectedValues[i]);
            while (currentIndex > 0) {
                currentIndex--;
                const optionEl = optionEls[currentIndex];
                if ((!skipNonExistent || !optionEl.classList.contains('non-existent')) && (!skipUnavailable || !optionEl.classList.contains("unavailable"))) {
                    selectedValues[i] = optionEl.value;
                    found = true;
                    break;
                }
            }
        }
        if (found) {
            if (inputType === "dropdown") {
                inputContainerEl.querySelector(".select__select").value = selectedValues[i];
            } else {
                inputContainerEl.querySelector("input[type=\"radio\"][value=\"" + selectedValues[i] + "\"]").checked = true;
            }
            containerEl.dispatchEvent(new Event("change"));
            return true;
        }
    }
    return false;
}
function updateGiftGoalInStorage({
    giftHandle: giftHandle,
    giftVariantId: giftVariantId,
    unlockType: unlockType,
    unlockRequirement: unlockRequirement,
    unlockTarget: unlockTarget
}) {
    const giftGoals = JSON.parse(localStorage.getItem("love_gift_goals")) || {};
    if (!giftHandle || !giftVariantId || !unlockRequirement || !unlockType) {
        return;
    }
    const goal = {
        'type': unlockType,
        'gift_handle': giftHandle,
        'gift_variant_id': Number(giftVariantId),
        'unlock_product_handle': unlockTarget || null
    };
    if (unlockType === "product_variant") {
        if (Array.isArray(unlockRequirement)) {
            goal.valid_variants = unlockRequirement.map(v => String(v).toLowerCase().trim());
        } else {
            goal.valid_variants = [String(unlockRequirement).toLowerCase().trim()];
        }
    } else {
        goal.required_quantity = Number(unlockRequirement);
    }
    giftGoals[giftHandle] = goal;
    localStorage.setItem("love_gift_goals", JSON.stringify(giftGoals));
}
class QuantityGifts extends HTMLElement {
    constructor() {
            super();
            this.gifts = this.querySelectorAll(".quantity-gift");
            this.quantityBreaks = document.getElementById("quantity-breaks-" + this.dataset.section);
            this.quantitySelector = document.getElementById("Quantity-Form--" + this.dataset.section);
            this.unlockedItems = [];
            this.mainProduct = this.dataset.mainProduct;
            this.cartItems = document.querySelector("cart-drawer-items");
            this.unlockBy = this.dataset.unlockBy === "variant" ? "variant" : 'quantity';
            this.initUnlock();
            this.saveLocalStorage = this.dataset.saveLocalStorage === 'true';
            if (this.saveLocalStorage && this.unlockBy !== 'variant') {
                this.storeLocalStorageData();
            }
        }
        ["connectedCallback"]() {
            if (this.unlockBy !== "variant") {
                return;
            }
            this._variantUnsub = subscribe('variant-change', ({
                data: eventData
            }) => {
                if (!eventData || eventData.sectionId !== this.dataset.section) {
                    return;
                }
                this.unlockGiftsByVariant(eventData.variant, false);
            });
        }
        ['disconnectedCallback']() {
            if (this._variantUnsub) {
                this._variantUnsub();
                this._variantUnsub = undefined;
            }
        }
        ["storeLocalStorageData"]() {
            this.gifts.forEach(giftEl => {
                updateGiftGoalInStorage({
                    'giftHandle': giftEl.dataset.handle,
                    'giftVariantId': giftEl.dataset.product,
                    'unlockType': 'product_quantity',
                    'unlockRequirement': giftEl.dataset.quantity,
                    'unlockTarget': this.mainProduct
                });
            });
        }
        ["initUnlock"]() {
            if (this.unlockBy === "variant") {
                const currentVariant = this._readCurrentVariant();
                this.unlockGiftsByVariant(currentVariant, true);
                return;
            }
            let quantity = 1;
            const mainProductEls = this.mainProduct ? document.querySelectorAll(".cart-item--product-" + this.mainProduct) : null;
            if (mainProductEls && mainProductEls.length) {
                quantity = 0;
                for (let i = 0; i < mainProductEls.length; i++) {
                    quantity += parseInt(mainProductEls[i].dataset.quantity);
                }
            } else {
                if (this.quantityBreaks) {
                    quantity = parseInt(this.quantityBreaks.selectedQuantity);
                } else {
                    if (this.quantitySelector) {
                        const inputEl = this.quantitySelector.querySelector("input[name=\"quantity\"]");
                        quantity = parseInt(inputEl.value);
                    }
                }
            }
            this.unlockGifts(quantity, true);
        }
        ['unlockGifts'](quantity, isInit = false) {
            if (this.unlockBy === 'variant') {
                return;
            }
            this.unlockedItems = [];
            this.gifts.forEach(giftEl => {
                if (parseInt(giftEl.dataset.quantity) <= quantity) {
                    giftEl.classList.add('quantity-gift--unlocked');
                    giftEl.dataset.unlocked = "true";
                    const cartItemEl = document.querySelector(".cart-item--product-" + giftEl.dataset.handle);
                    if (giftEl.dataset.product && !cartItemEl) {
                        this.unlockedItems.unshift(giftEl.dataset.product);
                    }
                } else {
                    giftEl.classList.remove("quantity-gift--unlocked");
                    giftEl.dataset.unlocked = "false";
                }
            });
            if (this.mainProduct && isInit) {
                this.addRemoveProducts();
            }
        }
        ['_readCurrentVariant']() {
            const variantSelectsEl = document.querySelector("variant-selects[data-section=\"" + this.dataset.section + "\"]");
            if (!variantSelectsEl) {
                return null;
            }
            if (variantSelectsEl.currentVariant) {
                return variantSelectsEl.currentVariant;
            }
            const selectedOptions = [];
            variantSelectsEl.querySelectorAll(".product-form__input").forEach(inputEl => {
                const typeEl = inputEl.querySelector(".product-form__input__type");
                const inputType = typeEl ? typeEl.dataset.type : null;
                let value;
                if (inputType === 'dropdown' || inputType === "dropdwon") {
                    const selectEl = inputEl.querySelector(".select__select");
                    value = selectEl ? selectEl.value : undefined;
                } else {
                    const radioEl = inputEl.querySelector("input[type=\"radio\"]:checked");
                    value = radioEl ? radioEl.value : undefined;
                }
                if (value !== undefined) {
                    selectedOptions.push(value);
                }
            });
            try {
                const jsonEl = variantSelectsEl.querySelector("[type=\"application/json\"]");
                if (!jsonEl) {
                    return null;
                }
                const variantData = JSON.parse(jsonEl.textContent);
                return variantData.find(v => Array.isArray(v.options) && v.options.length === selectedOptions.length && v.options.every((opt, i) => opt === selectedOptions[i])) || null;
            } catch (err) {
                return null;
            }
        }
        ['_getOptionOrders']() {
            const variantSelectsEl = document.querySelector("variant-selects[data-section=\"" + this.dataset.section + "\"]");
            if (!variantSelectsEl) {
                return null;
            }
            try {
                const jsonEl = variantSelectsEl.querySelector("[type=\"application/json\"]");
                if (!jsonEl) {
                    return null;
                }
                const variantData = JSON.parse(jsonEl.textContent);
                const optionOrders = {
                    'option1': [],
                    'option2': [],
                    'option3': []
                };
                variantData.forEach(variant => {
                    ["option1", 'option2', "option3"].forEach(optionKey => {
                        const value = variant[optionKey];
                        if (value !== null && value !== undefined) {
                            const normalized = String(value).toLowerCase().trim();
                            if (!optionOrders[optionKey].includes(normalized)) {
                                optionOrders[optionKey].push(normalized);
                            }
                        }
                    });
                });
                return optionOrders;
            } catch (err) {
                return null;
            }
        }
        ["unlockGiftsByVariant"](variant, isInit = false) {
            this.unlockedItems = [];
            if (!variant) {
                this.gifts.forEach(giftEl => {
                    giftEl.classList.remove("quantity-gift--unlocked");
                    giftEl.dataset.unlocked = "false";
                    if (this.saveLocalStorage) {
                        removeLocalStorageGift({
                            'gift_handle': giftEl.dataset.handle
                        });
                    }
                });
                if (this.mainProduct && isInit) {
                    this.addRemoveProducts();
                }
                return;
            }
            const optionOrders = this._getOptionOrders();
            const currentOptions = {
                'option1': variant.option1 ? String(variant.option1).toLowerCase().trim() : null,
                'option2': variant.option2 ? String(variant.option2).toLowerCase().trim() : null,
                'option3': variant.option3 ? String(variant.option3).toLowerCase().trim() : null
            };
            this.gifts.forEach(giftEl => {
                const giftVariantValue = (giftEl.dataset.variant || '').toLowerCase().trim();
                if (!giftVariantValue.length) {
                    giftEl.classList.remove('quantity-gift--unlocked');
                    giftEl.dataset.unlocked = 'false';
                    if (this.saveLocalStorage) {
                        removeLocalStorageGift({
                            'gift_handle': giftEl.dataset.handle
                        });
                    }
                    return;
                }
                let isUnlocked = false;
                let matchedRequirement = [];
                if (optionOrders) {
                    for (const optionKey of ["option1", "option2", "option3"]) {
                        const order = optionOrders[optionKey];
                        const giftIndex = order.indexOf(giftVariantValue);
                        if (giftIndex === -1) {
                            continue;
                        }
                        const currentValue = currentOptions[optionKey];
                        const currentIndex = currentValue ? order.indexOf(currentValue) : -1;
                        if (currentIndex >= giftIndex) {
                            isUnlocked = true;
                            matchedRequirement = order.slice(giftIndex);
                        }
                        break;
                    }
                }
                if (!optionOrders) {
                    const variantValues = [variant.title, variant.option1, variant.option2, variant.option3, ...(Array.isArray(variant.options) ? variant.options : [])].filter(v => v !== undefined && v !== null).map(v => String(v).toLowerCase().trim());
                    isUnlocked = variantValues.includes(giftVariantValue);
                    matchedRequirement = [giftVariantValue];
                }
                if (isUnlocked) {
                    giftEl.classList.add("quantity-gift--unlocked");
                    giftEl.dataset.unlocked = 'true';
                    const cartItemEl = document.querySelector(".cart-item--product-" + giftEl.dataset.handle);
                    if (giftEl.dataset.product && !cartItemEl) {
                        this.unlockedItems.unshift(giftEl.dataset.product);
                    }
                    if (this.saveLocalStorage) {
                        updateGiftGoalInStorage({
                            'giftHandle': giftEl.dataset.handle,
                            'giftVariantId': giftEl.dataset.product,
                            'unlockType': "product_variant",
                            'unlockRequirement': matchedRequirement,
                            'unlockTarget': this.mainProduct
                        });
                    }
                } else {
                    giftEl.classList.remove("quantity-gift--unlocked");
                    giftEl.dataset.unlocked = "false";
                    if (this.saveLocalStorage) {
                        removeLocalStorageGift({
                            'gift_handle': giftEl.dataset.handle
                        });
                    }
                }
            });
            if (this.mainProduct && isInit) {
                this.addRemoveProducts();
            }
        }
        ["addRemoveProducts"]() {
            if (!this.mainProduct) {
                return;
            }
            const mainProductEls = document.querySelectorAll(".cart-item--product-" + this.mainProduct);
            this.gifts.forEach(giftEl => {
                if (mainProductEls.length) {
                    if (giftEl.dataset.unlocked === "true" && giftEl.dataset.product) {
                        this.addToCart(giftEl);
                    } else {
                        this.removeFromCart(giftEl);
                    }
                } else {
                    this.removeFromCart(giftEl);
                }
            });
        }
        ["addToCart"](giftEl) {
            const existingEl = document.querySelector(".cart-item--product-" + giftEl.dataset.handle);
            if (existingEl) {
                return;
            }
            const productFormEl = giftEl.querySelector("product-form");
            if (productFormEl && productFormEl.handleSubmit) {
                productFormEl.handleSubmit();
            }
        }
        ['removeFromCart'](giftEl) {
            const cartItemEl = document.querySelector(".cart-item--product-" + giftEl.dataset.handle);
            if (!cartItemEl || !this.cartItems) {
                return;
            }
            this.cartItems.updateQuantity(cartItemEl.dataset.index, 0);
        }
}
customElements.define("quantity-gifts", QuantityGifts);
class QuantityBreakUpsells extends QuantityGifts {
    constructor() {
            super();
            this.offerIndex = this.dataset.offer;
            this.upsells = this.querySelectorAll(".quantity-break__upsell");
            this.boundToggleHandler = this.handleToggle.bind(this);
            this.upsells.forEach(upsellEl => {
                if (upsellEl.dataset.toggle === "true") {
                    upsellEl.addEventListener("click", this.boundToggleHandler);
                }
            });
            this.initUnlock();
            if (this.saveLocalStorage) {
                this.storeLocalStorageData();
            }
        }
        ["storeLocalStorageData"]() {
            if (!this.upsells) {
                return;
            }
            this.upsells.forEach(upsellEl => {
                if (upsellEl.dataset.type !== 'gift') {
                    return;
                }
                updateGiftGoalInStorage({
                    'giftHandle': upsellEl.dataset.handle,
                    'giftVariantId': upsellEl.dataset.product,
                    'unlockType': "product_quantity",
                    'unlockRequirement': upsellEl.dataset.minQuantity,
                    'unlockTarget': this.dataset.mainProduct
                });
            });
        }
        ["disconnectedCallback"]() {
            this.upsells.forEach(upsellEl => {
                if (upsellEl.dataset.toggle === "true") {
                    upsellEl.removeEventListener("click", this.boundToggleHandler);
                }
            });
        }
        ["unlockGifts"](quantity, isInit = false) {
            this.unlockedItems = [];
            if (!this.upsells) {
                return;
            }
            this.upsells.forEach(upsellEl => {
                const minQuantity = parseInt(upsellEl.dataset.minQuantity || 0);
                const meetsQuantity = quantity >= minQuantity;
                const isSelected = upsellEl.dataset.selected === "true";
                const isUnlocked = meetsQuantity && isSelected;
                upsellEl.dataset.unlocked = isUnlocked.toString();
                upsellEl.classList.toggle("quantity-gift--unlocked", isUnlocked);
                const cartItemEl = document.querySelector('.cart-item--product-' + upsellEl.dataset.handle);
                if (isUnlocked && upsellEl.dataset.product && !cartItemEl) {
                    const isToggle = upsellEl.dataset.toggle === "true";
                    const toggleSelected = upsellEl.dataset.selected === "true";
                    if (!isToggle || isToggle && toggleSelected) {
                        this.unlockedItems.unshift(upsellEl.dataset.product);
                    }
                }
            });
            if (this.mainProduct && isInit) {
                if (this.dataset.lastOffer === this.dataset.offer) {
                    this.addRemoveProducts();
                }
            }
        }
        ["addRemoveProducts"]() {
            if (!this.mainProduct) {
                return;
            }
            const mainProductEls = document.querySelectorAll(".cart-item--product-" + this.mainProduct);
            const toAdd = [];
            const toRemove = [];
            this.upsells.forEach(upsellEl => {
                const cartItemEl = document.querySelector(".cart-item--product-" + upsellEl.dataset.handle);
                const isUnlocked = upsellEl.dataset.unlocked === "true";
                if (mainProductEls.length) {
                    if (isUnlocked && !cartItemEl) {
                        toAdd.push(upsellEl);
                    } else if (!isUnlocked && cartItemEl) {
                        toRemove.push(upsellEl);
                    }
                } else if (cartItemEl) {
                    toRemove.push(upsellEl);
                }
            });
            if (toRemove.length) {
                this.removeFromCart(toRemove[0]);
            } else if (toAdd.length) {
                this.addToCart(toAdd[0]);
            }
        }
        ["handleToggle"](event) {
            const upsellEl = event.currentTarget;
            const wasSelected = upsellEl.dataset.selected === "true";
            upsellEl.dataset.selected = (!wasSelected).toString();
            this.syncUpsellAcrossOffers(upsellEl.dataset.handle, !wasSelected);
            this.syncCart(upsellEl.dataset.handle, !wasSelected, upsellEl);
        }
        ["syncUpsellAcrossOffers"](handle, isSelected) {
            const allUpsellGroups = document.querySelectorAll("quantity-break-upsells");
            allUpsellGroups.forEach(groupEl => {
                groupEl.querySelectorAll(".quantity-break__upsell[data-handle=\"" + handle + "\"]").forEach(upsellEl => {
                    upsellEl.dataset.selected = isSelected.toString();
                });
            });
        }
        ["syncCart"](handle, isSelected, upsellEl) {
            const cartItemEl = document.querySelector(".cart-item--product-" + handle);
            if (!this.cartItems) {
                return;
            }
            if (isSelected && !cartItemEl) {
                this.addToCart(upsellEl);
            } else if (!isSelected && cartItemEl) {
                this.removeFromCart(upsellEl);
            }
        }
}
customElements.define("quantity-break-upsells", QuantityBreakUpsells);
class ProductInfoUpsell extends HTMLElement {
    constructor() {
            super();
            this.image = this.querySelector(".upsell__image__img");
            this.toggleBtn = this.querySelector(".upsell-toggle-btn");
            this.variantSelects = this.querySelector('.upsell__variant-picker');
            this.variantSelectElements = this.querySelectorAll(".select__select");
            this.jsonData = this.querySelector("[type=\"application/json\"]");
            this.productForm = this.querySelector("product-form");
            if (this.productForm) {
                this.idInput = this.productForm.querySelector("[name=\"id\"]");
            }
            this.skipNonExistent = this.dataset.skipNonExistent === "true";
            this.skipUnavailable = this.dataset.skipUnavailable === "true";
            this.updatePrices = this.dataset.updatePrices === "true";
            if (this.updatePrices) {
                this.price = parseInt(this.dataset.price);
                this.comparePrice = parseInt(this.dataset.comparePrice);
                this.priceSpan = this.querySelector(".upsell__price .regular-price");
                this.comparePriceSpan = this.querySelector(".upsell__price .compare-price");
                this.percentageLeft = parseFloat(this.dataset.percentageLeft);
                this.fixedDiscount = parseFloat(this.dataset.fixedDiscount);
                this.moneyFormat = this.dataset.moneyFormat;
                this.isMainOfferItem = this.dataset.mainOfferItem === "true";
                if (this.isMainOfferItem) {
                    this.mainOfferContainer = document.querySelector("#MainBundleOffer-" + this.dataset.section);
                }
            }
            if (this.toggleBtn) {
                this.toggleBtn.addEventListener("click", this.handleToggle.bind(this));
            }
            if (this.variantSelects) {
                this.variantSelects.addEventListener("change", this.handleSelectChange.bind(this));
            }
        }
        ["handleToggle"](event) {
            if (event.target.nodeName.toLowerCase() === "select" || event.target.nodeName.toLowerCase() === "option") {
                return;
            }
            if (this.dataset.selected === "true") {
                this.dataset.selected = 'false';
            } else {
                this.dataset.selected = 'true';
            }
        }
        ['handleSelectChange'](event) {
            const pickerEl = event.currentTarget;
            const selectedValues = Array.from(pickerEl.querySelectorAll("select"), selectEl => selectEl.value);
            const matchedVariant = this.getVariantData().find(variant => {
                return !variant.options.map((opt, i) => {
                    return selectedValues[i] === opt;
                }).includes(false);
            });
            const matchingByOption1 = this.getVariantData().filter(variant => pickerEl.querySelector(":checked").value === variant.option1);
            const smallSelects = [...pickerEl.querySelectorAll("select")];
            updateVariantStatuses(matchingByOption1, smallSelects, this.skipUnavailable);
            if (!matchedVariant) {
                if (this.skipNonExistent) {
                    findAvailableVariant(pickerEl, selectedValues, false, true, this.skipUnavailable);
                }
                return;
            }
            if (this.skipUnavailable && !matchedVariant.available) {
                if (findAvailableVariant(pickerEl, selectedValues, false, true, true)) {
                    return;
                }
            }
            if (this.updatePrices) {
                this.price = matchedVariant.price * this.percentageLeft - this.fixedDiscount;
                this.comparePrice = matchedVariant.price;
                if (matchedVariant.compare_at_price && matchedVariant.compare_at_price > matchedVariant.price) {
                    this.comparePrice = matchedVariant.compare_at_price;
                }
                displayPrices(this.price, this.comparePrice, this.priceSpan, this.comparePriceSpan, this.moneyFormat);
            }
            if (this.image && matchedVariant.featured_image) {
                this.image.src = matchedVariant.featured_image.src;
            }
            this.updateId(matchedVariant.id);
            if (this.isMainOfferItem && this.mainOfferContainer.updateTotalPrices) {
                this.mainOfferContainer.updateTotalPrices();
            }
        }
        ["updateId"](variantId) {
            this.dataset.id = variantId;
            if (this.idInput) {
                this.idInput.value = variantId;
            }
        }
        ["getVariantData"]() {
            this.variantData = this.variantData || JSON.parse(this.jsonData.textContent);
            return this.variantData;
        }
}
customElements.define("product-info-upsell", ProductInfoUpsell);
class CartDrawerUpsell extends ProductInfoUpsell {
    constructor() {
            super();
            this.cartDrawer = document.querySelector("cart-drawer");
            this.cartItems = this.cartDrawer ? this.cartDrawer.querySelector('cart-drawer-items') : null;
            this.classicAddButton = this.querySelector('.upsell__add-btn');
        }
        ["handleToggle"](event) {
            if (event.target.nodeName.toLowerCase() === "select" || event.target.nodeName.toLowerCase() === "option") {
                return;
            }
            if (this.dataset.selected === 'true') {
                this.dataset.selected = "false";
                this.removeFromCart();
            } else {
                this.dataset.selected = 'true';
                this.addToCart();
            }
        }
        ["addRemoveFromCart"]() {
            if (this.dataset.selected === 'true' && !this.cartDrawer.classList.contains("is-empty")) {
                this.addToCart();
            } else {
                this.removeFromCart();
            }
        }
        ["addToCart"]() {
            const existingEl = this.cartDrawer.querySelector(".cart-item--product-" + this.dataset.handle);
            if (existingEl) {
                return;
            }
            if (this.toggleBtn) {
                this.toggleBtn.setAttribute("disabled", '');
            }
            this.variantSelectElements.forEach(selectEl => {
                selectEl.setAttribute("disabled", '');
            });
            this.productForm.handleSubmit();
        }
        ["removeFromCart"]() {
            const cartItemEl = this.cartDrawer.querySelector(".cart-item--product-" + this.dataset.handle);
            if (!cartItemEl || !this.cartItems) {
                return;
            }
            if (this.toggleBtn) {
                this.toggleBtn.setAttribute('disabled', '');
            }
            this.variantSelectElements.forEach(selectEl => {
                selectEl.setAttribute("disabled", '');
            });
            this.cartItems.updateQuantity(cartItemEl.dataset.index, 0);
        }
        ["updateId"](variantId) {
            this.dataset.id = variantId;
            this.idInput.value = variantId;
            if (this.classicAddButton) {
                return;
            }
            if (this.dataset.selected === "true") {
                if (this.selectTimeout) {
                    clearTimeout(this.selectTimeout);
                }
                this.removeFromCart();
                const onCartQuantityUpdated = event => {
                    if (event.detail.handle === 'handle') {
                        this.addToCart();
                        document.removeEventListener("cartQuantityUpdated", onCartQuantityUpdated);
                    }
                };
                document.addEventListener("cartQuantityUpdated", onCartQuantityUpdated);
            }
        }
        ["getUpdateRequired"]() {
            const cartItemEl = this.cartDrawer.querySelector(".cart-item--product-" + this.dataset.handle);
            let needsUpdate = false;
            if (cartItemEl && this.dataset.selected === 'false') {
                needsUpdate = true;
            } else if (!cartItemEl && this.dataset.selected === "true") {
                needsUpdate = true;
            }
            return needsUpdate;
        }
}
customElements.define("cart-drawer-upsell", CartDrawerUpsell);
function displayPrices(price, comparePrice, priceEl, comparePriceEl, moneyFormat) {
    if (!moneyFormat) {
        return;
    }
    if (price && priceEl) {
        var formattedPrice = formatMoney(price, moneyFormat);
        priceEl.innerHTML = formattedPrice;
    }
    if (comparePrice && comparePriceEl) {
        var formattedComparePrice = formatMoney(comparePrice, moneyFormat);
        comparePriceEl.innerHTML = formattedComparePrice;
        if (comparePrice > price) {
            comparePriceEl.classList.remove("hidden");
        } else {
            comparePriceEl.classList.add("hidden");
        }
    }
}
function initTrapFocus() {
    isIe = false;
    if (document.querySelector("footer") && document.querySelector('footer').dataset.type === null) {
        return false;
    }
    return true;
}
function formatMoney(cents, format, trimZeroCents = false) {
    if (typeof cents == "string") {
        cents = cents.replace('.', '');
    }
    var result = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    function formatWithSeparators(amountInCents, decimals, thousandsSep, decimalSep) {
        decimals = typeof decimals == "undefined" ? 2 : decimals;
        thousandsSep = typeof thousandsSep == "undefined" ? ',' : thousandsSep;
        decimalSep = typeof decimalSep == "undefined" ? '.' : decimalSep;
        if (isNaN(amountInCents) || amountInCents == null) {
            return 0;
        }
        amountInCents = (amountInCents / 100).toFixed(decimals);
        var parts = amountInCents.split('.');
        var integerPart = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousandsSep);
        var decimalPart = parts[1] ? decimalSep + parts[1] : '';
        if (trimZeroCents && decimalPart === decimalSep + '00') {
            decimalPart = '';
        }
        return integerPart + decimalPart;
    }
    switch (format.match(placeholderRegex)[1]) {
    case 'amount':
        result = formatWithSeparators(cents, 2);
        break;
    case "amount_no_decimals":
        result = formatWithSeparators(cents, 0);
        break;
    case "amount_with_comma_separator":
        result = formatWithSeparators(cents, 2, '.', ',');
        break;
    case "amount_no_decimals_with_comma_separator":
        result = formatWithSeparators(cents, 0, '.', ',');
        break;
    case "amount_with_space_separator":
        result = formatWithSeparators(cents, 2, " ", ',');
        break;
    case 'amount_no_decimals_with_space_separator':
        result = formatWithSeparators(cents, 0, " ", ',');
        break;
    case "amount_with_apostrophe_separator":
        result = formatWithSeparators(cents, 2, "'", '.');
        break;
    case 'amount_no_decimals_with_apostrophe_separator':
        result = formatWithSeparators(cents, 0, "'", '.');
        break;
    }
    return format.replace(placeholderRegex, result);
}
class CartDrawerGift extends CartDrawerUpsell {
    constructor() {
            super();
            this.saveLocalStorage = this.dataset.saveLocalStorage === 'true';
            if (this.saveLocalStorage) {
                this.storeLocalStorageData();
            }
        }
        ["storeLocalStorageData"]() {
            if (!this.dataset.handle || !this.dataset.id || !this.dataset.mainProduct || !this.dataset.requirement || !this.dataset.type) {
                return;
            }
            updateGiftGoalInStorage({
                'giftHandle': this.dataset.handle,
                'giftVariantId': this.dataset.id,
                'unlockType': this.dataset.type,
                'unlockRequirement': Number(this.dataset.requirement),
                'unlockTarget': this.dataset.mainProduct
            });
        }
}
customElements.define("cart-drawer-gift", CartDrawerGift);
function initToggleUpsells() {
    const cartDrawerEl = document.querySelector("cart-drawer");
    if (cartDrawerEl) {
        cartDrawerEl.querySelectorAll("cart-drawer-upsell[data-toggle=\"true\"], cart-drawer-gift").forEach(upsellEl => {
            if (upsellEl.addRemoveFromCart) {
                upsellEl.addRemoveFromCart();
            }
        });
    }
}
initToggleUpsells();
class MainBundleOffer extends HTMLElement {
    constructor() {
            super();
            this.offerItems = this.querySelectorAll(".main-offer-item");
            this.updatePrices = this.dataset.updatePrices === "true";
            if (this.updatePrices) {
                this.priceSpan = this.querySelector('.bundle-deals__total-price-js');
                this.comparePriceSpan = this.querySelector(".bundle-deals__total-compare-price-js");
                this.percentageLeft = parseFloat(this.dataset.percentageLeft);
                this.fixedDiscount = parseFloat(this.dataset.fixedDiscount);
                this.moneyFormat = this.dataset.moneyFormat;
            }
        }
        ["updateTotalPrices"]() {
            if (!this.updatePrices) {
                return;
            }
            var totalPrice = 0;
            var totalComparePrice = 0;
            for (let i = 0; i < this.offerItems.length; i++) {
                totalPrice += parseInt(this.offerItems[i].price);
                totalComparePrice += parseInt(this.offerItems[i].comparePrice);
            }
            totalPrice = totalPrice * this.percentageLeft - this.fixedDiscount;
            displayPrices(totalPrice, totalComparePrice, this.priceSpan, this.comparePriceSpan, this.moneyFormat);
        }
}
customElements.define('main-bundle-offer', MainBundleOffer);
class CustomProductField extends HTMLElement {
    constructor() {
            super();
        }
        ['connectedCallback']() {
            this.fieldName = this.dataset.name;
            this.input = this.querySelector("[type=\"text\"], [type=\"number\"], textarea");
            this.inputRadios = this.querySelectorAll("[type=\"radio\"]");
            this.select = this.querySelector('.select__select');
            this.productForm = document.getElementById("product-form-" + this.dataset.section);
            this.prevValue = this.dataset.defaultValue;
            this.isRequired = this.dataset.required === 'true';
            this.isText = true;
            this.notMain = this.dataset.notMain === "true";
            if (this.dataset.type === 'select' || this.dataset.type === "pills") {
                this.isText = false;
            }
            this.createInputs();
            if (this.isRequired && this.isText) {
                this.isValid = true;
                this.atcButtons = this.notMain ? document.querySelectorAll(".featured-product-atc-" + this.dataset.section) : document.querySelectorAll('.main-product-atc');
                this.mainAtcButton = this.productForm.querySelector("#ProductSubmitButton-" + this.dataset.section);
                this.mainAtcBtnLabel = this.mainAtcButton.querySelector(".main-atc__label");
                this.mainAtcBtnError = this.mainAtcButton.querySelector(".main-atc__error");
                this.atcErrorMsg = this.dataset.atcErrorMsg;
                this.mainAtcButton.dataset.requiredFields = parseInt(this.mainAtcButton.dataset.requiredFields) + 1;
                if (this.mainAtcBtnError) {
                    this.mainAtcBtnError.innerHTML = this.atcErrorMsg;
                }
                this.applyStickyAtcError = this.dataset.applyStickyAtcError === "true";
                this.stickyAtcButton = document.querySelector("#sticky-atc-" + this.dataset.section);
                if (this.applyStickyAtcError && this.stickyAtcButton) {
                    this.stickyAtcBtnLabel = this.stickyAtcButton.querySelector(".sticky-atc__label");
                    this.stickyAtcBtnError = this.stickyAtcButton.querySelector(".sticky-atc__error");
                    if (this.stickyAtcBtnError) {
                        this.stickyAtcBtnError.innerHTML = this.atcErrorMsg;
                    }
                }
                this.validateValue(this.prevValue, null);
            }
            if (this.input) {
                this.input.addEventListener('input', this.handleChange.bind(this));
            }
            this.inputRadios.forEach(radioEl => {
                radioEl.addEventListener("input", this.handleChange.bind(this));
            });
            if (this.select) {
                this.select.addEventListener("change", this.handleChange.bind(this));
            }
        }
        ["handleChange"](event) {
            const value = event.target.value.trim();
            if (event.target.checkValidity()) {
                this.prevValue = value;
            } else {
                event.target.value = this.prevValue;
                return;
            }
            this.dataset.value = value;
            this.productFormInput.value = value;
            if (this.isRequired && this.isText) {
                this.validateValue(value, event.target);
            }
        }
        ["validateValue"](value, inputEl) {
            const isValid = !!(value.length > 0);
            if (isValid === this.isValid) {
                return;
            }
            this.isValid = isValid;
            if (inputEl) {
                if (this.isValid) {
                    inputEl.classList.remove("input--error");
                    this.mainAtcButton.dataset.validFields = parseInt(this.mainAtcButton.dataset.validFields) + 1;
                } else {
                    inputEl.classList.add("input--error");
                    this.mainAtcButton.dataset.validFields = parseInt(this.mainAtcButton.dataset.validFields) - 1;
                }
            }
            const allFieldsValid = this.mainAtcButton.dataset.validFields === this.mainAtcButton.dataset.requiredFields;
            const isUnavailable = this.mainAtcButton.dataset.unavailable === "true";
            this.atcButtons.forEach(btnEl => {
                if (allFieldsValid && !isUnavailable) {
                    btnEl.removeAttribute("disabled");
                } else {
                    btnEl.setAttribute("disabled", '');
                }
            });
            if (this.atcErrorMsg.length === 0) {
                return;
            }
            if (allFieldsValid) {
                this.mainAtcBtnLabel.style.display = '';
                this.mainAtcBtnError.style.display = "none";
                if (this.applyStickyAtcError && this.stickyAtcButton) {
                    this.stickyAtcBtnLabel.style.display = '';
                    this.stickyAtcBtnError.style.display = "none";
                }
            } else {
                this.mainAtcBtnLabel.style.display = "none";
                this.mainAtcBtnError.style.display = '';
                if (this.applyStickyAtcError && this.stickyAtcButton) {
                    this.stickyAtcBtnLabel.style.display = 'none';
                    this.stickyAtcBtnError.style.display = '';
                }
            }
        }
        ["createInputs"]() {
            this.productFormInput = document.createElement("input");
            this.productFormInput.setAttribute("type", 'hidden');
            this.productFormInput.setAttribute("name", "properties[" + this.fieldName + ']');
            this.productFormInput.value = this.dataset.defaultValue;
            this.productFormInput.classList.add("love-property-input");
            this.productForm.appendChild(this.productFormInput);
        }
}
customElements.define("custom-product-field", CustomProductField);
function playMedia() {
    if (!serial) {
        serial = document.currentScript.dataset.animationsType || '';
    }
}
class VariantSelects extends HTMLElement {
    constructor() {
            super();
            this.secondarySelectSelector = "StickyAtcVariantPicker-";
            this.secondarySelect = document.getElementById('' + this.secondarySelectSelector + this.dataset.section);
            this.isSecondary = false;
            this.QuantityBreaks = document.getElementById("quantity-breaks-" + this.dataset.section);
            this.hasQuantityBreaksPicker = this.dataset.hasQuantityBreaksPicker === "true";
            this.prependMedia = this.dataset.disablePrepend != "true";
            this.filtering = this.dataset.hasFiltering === "true";
            this.skipNonExistent = this.dataset.skipNonExistent === "true";
            this.skipUnavailable = this.dataset.skipUnavailable === "true";
            if (this.hasQuantityBreaksPicker) {
                this.quantityBreaksPickerStyle = this.dataset.quantityBreaksPickerStyle;
                this.quantityBreaksPickerDisplayedImages = this.dataset.quantityBreaksPickerDisplayedImages;
            }
            this.addEventListener("change", this.onVariantChange);
        }
        ["onVariantChange"]() {
            this.updateOptions();
            this.updateMasterId();
            this.toggleAddButton(true, '', false);
            this.updatePickupAvailability();
            this.removeErrorMessage();
            this.updateVariantStatuses();
            if (!this.currentVariant) {
                this.toggleAddButton(true, '', true);
                if (this.skipNonExistent && findAvailableVariant(this, this.options, true, true, this.skipUnavailable)) {
                    return;
                }
                this.setUnavailable();
            } else {
                if (this.skipUnavailable && !this.currentVariant.available) {
                    if (findAvailableVariant(this, this.options, true, true, true)) {
                        return;
                    }
                }
                this.updateMedia();
                this.updateURL();
                this.updateVariantInput();
                this.renderProductInfo();
                this.updateShareUrl();
            }
        }
        ["updateOptions"]() {
            const options = [];
            this.querySelectorAll(".product-form__input").forEach(inputEl => {
                let value;
                const inputType = inputEl.querySelector(".product-form__input__type").dataset.type;
                if (inputType == "dropdown" || inputType == "dropdwon") {
                    value = inputEl.querySelector('.select__select').value;
                } else {
                    value = inputEl.querySelector("input[type=\"radio\"]:checked").value;
                }
                options.push(value);
            });
            this.options = options;
        }
        ["updateMasterId"]() {
            this.currentVariant = this.getVariantData().find(variant => {
                return !variant.options.map((opt, i) => {
                    return this.options[i] === opt;
                }).includes(false);
            });
        }
        ['updateMedia']() {
            if (!this.currentVariant) {
                return;
            }
            if (!this.currentVariant.featured_media) {
                return;
            }
            const galleryEls = document.querySelectorAll("[id^=\"MediaGallery-" + this.dataset.section + "\"]");
            galleryEls.forEach(galleryEl => galleryEl.setActiveMedia(this.dataset.section + '-' + this.currentVariant.featured_media.id, this.prependMedia, this.filtering, this.currentVariant));
            const modalContentEl = document.querySelector("#ProductModal-" + this.dataset.section + " .product-media-modal__content");
            if (!modalContentEl) {
                return;
            }
            const mediaEl = modalContentEl.querySelector("[data-media-id=\"" + this.currentVariant.featured_media.id + "\"]");
            modalContentEl.prepend(mediaEl);
        }
        ['updateURL']() {
            if (!this.currentVariant || this.dataset.updateUrl === "false") {
                return;
            }
            window.history.replaceState({}, '', this.dataset.url + '?variant=' + this.currentVariant.id);
        }
        ["updateShareUrl"]() {
            const shareEl = document.getElementById("Share-" + this.dataset.section);
            if (!shareEl || !shareEl.updateUrl) {
                return;
            }
            shareEl.updateUrl('' + window.shopUrl + this.dataset.url + "?variant=" + this.currentVariant.id);
        }
        ["updateVariantInput"]() {
            const formEls = document.querySelectorAll('#product-form-' + this.dataset.section + ", #product-form-installment-" + this.dataset.section);
            formEls.forEach(formEl => {
                const idInputEl = formEl.querySelector("input[name=\"id\"]");
                idInputEl.value = this.currentVariant.id;
                idInputEl.dispatchEvent(new Event("change", {
                    'bubbles': true
                }));
            });
        }
        ["updateVariantStatuses"]() {
            const matchingByOption1 = this.variantData.filter(variant => this.querySelector(":checked").value === variant.option1);
            let inputGroups;
            if (this.isSecondary && this.secondarySelect) {
                inputGroups = [...this.secondarySelect.querySelectorAll(".product-form__input")];
            } else {
                inputGroups = [...this.querySelectorAll(".product-form__input")];
            }
            inputGroups.forEach((inputGroupEl, i) => {
                if (i === 0) {
                    return;
                }
                const optionEls = [...inputGroupEl.querySelectorAll("input[type=\"radio\"], .select__select option")];
                const previousSelectedValue = inputGroups[i - 1].querySelector(":checked").value;
                const availableValues = matchingByOption1.filter(variant => variant.available && variant["option" + i] === previousSelectedValue).map(variant => variant["option" + (i + 1)]);
                const existingValues = matchingByOption1.filter(variant => variant["option" + i] === previousSelectedValue).map(variant => variant['option' + (i + 1)]);
                this.setInputAvailability(optionEls, availableValues, existingValues, this.skipNonExistent, this.skipUnavailable);
            });
        }
        ["setInputAvailability"](optionEls, availableValues, existingValues, skipNonExistent = false, skipUnavailable = false) {
            optionEls.forEach(optionEl => {
                optionEl.classList.remove("unavailable", "non-existent", "disabled");
                optionEl.removeAttribute("disabled");
                optionEl.removeAttribute("hidden");
                const value = optionEl.getAttribute("value");
                let swatchEl = null;
                if (optionEl.dataset.swatch === "true") {
                    swatchEl = optionEl.closest(".color-swatch");
                }
                if (swatchEl) {
                    swatchEl.classList.remove("unavailable", "non-existent", 'disabled');
                }
                if (existingValues.includes(value)) {
                    if (availableValues.includes(value)) {
                        if (optionEl.nodeName === "OPTION") {
                            optionEl.innerText = value;
                        } else {
                            optionEl.classList.remove("disabled");
                            if (swatchEl) {
                                swatchEl.classList.remove("disabled");
                            }
                        }
                    } else {
                        if (optionEl.nodeName === "OPTION") {
                            optionEl.innerText = window.variantStrings.unavailable_with_option.replace('[value]', value);
                            optionEl.classList.add("unavailable");
                            if (skipUnavailable) {
                                optionEl.setAttribute("disabled", '');
                                optionEl.setAttribute("hidden", '');
                            }
                        } else {
                            optionEl.classList.add("disabled", 'unavailable');
                            if (swatchEl) {
                                swatchEl.classList.add("disabled", 'unavailable');
                            }
                        }
                    }
                } else {
                    if (optionEl.nodeName === "OPTION") {
                        optionEl.innerText = window.variantStrings.unavailable_with_option.replace('[value]', value);
                        optionEl.classList.add("non-existent");
                        if (skipNonExistent) {
                            optionEl.setAttribute("disabled", '');
                            optionEl.setAttribute("hidden", '');
                        }
                    } else {
                        optionEl.classList.add("disabled", "non-existent");
                        if (swatchEl) {
                            swatchEl.classList.add('disabled', "non-existent");
                        }
                    }
                }
            });
        }
        ['updatePickupAvailability']() {
            const pickupEl = document.querySelector("pickup-availability");
            if (!pickupEl) {
                return;
            }
            if (this.currentVariant && this.currentVariant.available) {
                if (pickupEl.fetchAvailability) {
                    pickupEl.fetchAvailability(this.currentVariant.id);
                }
            } else {
                pickupEl.removeAttribute("available");
                pickupEl.innerHTML = '';
            }
        }
        ["removeErrorMessage"]() {
            const sectionEl = this.closest("section");
            if (!sectionEl) {
                return;
            }
            const productFormEl = sectionEl.querySelector('product-form');
            if (productFormEl) {
                productFormEl.handleErrorMessage();
            }
        }
        ['renderProductInfo']() {
            const variantId = this.currentVariant.id;
            const effectiveSection = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
            fetch(this.dataset.url + "?variant=" + variantId + "&section_id=" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section)).then(response => response.text()).then(html => {
                if (this.currentVariant.id !== variantId) {
                    return;
                }
                const parsedDoc = new DOMParser().parseFromString(html, "text/html");
                const currentPriceEl = document.getElementById("price-" + this.dataset.section);
                const newPriceEl = parsedDoc.getElementById("price-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section));
                const currentSeparatePriceEl = document.getElementById("sticky-atc-separate-price-" + this.dataset.section);
                const newSeparatePriceEl = parsedDoc.getElementById("sticky-atc-separate-price-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section));
                const currentStickyPriceEl = document.getElementById("sticky-atc-price-" + this.dataset.section);
                const newStickyPriceEl = parsedDoc.getElementById("sticky-atc-price-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section));
                const stickyImageEl = document.getElementById("sticky-atc-image-" + this.dataset.section);
                if (stickyImageEl && this.currentVariant.featured_image) {
                    stickyImageEl.src = this.currentVariant.featured_image.src;
                }
                const currentAtcPriceEl = document.getElementById("main-atc-price-" + this.dataset.section);
                const newAtcPriceEl = parsedDoc.getElementById('main-atc-price-' + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section));
                const currentCustomLabelEls = document.querySelectorAll("[id^=\"custom-label-" + this.dataset.section + "\"]");
                const newCustomLabelEls = parsedDoc.querySelectorAll("[id^=\"custom-label-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section) + "\"]");
                const newSkuEl = parsedDoc.getElementById("Sku-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section));
                const currentSkuEl = document.getElementById("Sku-" + this.dataset.section);
                const newInventoryEl = parsedDoc.getElementById('Inventory-' + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section));
                const currentInventoryEl = document.getElementById("Inventory-" + this.dataset.section);
                if (currentPriceEl && newPriceEl) {
                    currentPriceEl.innerHTML = newPriceEl.innerHTML;
                }
                if (currentSeparatePriceEl && newSeparatePriceEl) {
                    currentSeparatePriceEl.innerHTML = newSeparatePriceEl.innerHTML;
                }
                if (currentStickyPriceEl && newStickyPriceEl) {
                    currentStickyPriceEl.innerHTML = newStickyPriceEl.innerHTML;
                }
                if (newAtcPriceEl && currentAtcPriceEl) {
                    currentAtcPriceEl.innerHTML = newAtcPriceEl.innerHTML;
                }
                if (currentCustomLabelEls && newCustomLabelEls) {
                    for (var i = 0; i < currentCustomLabelEls.length; i++) {
                        currentCustomLabelEls[i].innerHTML = newCustomLabelEls[i].innerHTML;
                    }
                }
                if (newInventoryEl && currentInventoryEl) {
                    currentInventoryEl.innerHTML = newInventoryEl.innerHTML;
                }
                if (newSkuEl && currentSkuEl) {
                    currentSkuEl.innerHTML = newSkuEl.innerHTML;
                    currentSkuEl.classList.toggle('visibility-hidden', newSkuEl.classList.contains('visibility-hidden'));
                }
                if (this.QuantityBreaks) {
                    const newQuantityBreaksEl = parsedDoc.getElementById("quantity-breaks-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section));
                    const currentDynamicPriceEls = this.QuantityBreaks.querySelectorAll(".dynamic-price");
                    const newDynamicPriceEls = newQuantityBreaksEl.querySelectorAll(".dynamic-price");
                    for (let i = 0; i < currentDynamicPriceEls.length; i++) {
                        currentDynamicPriceEls[i].innerHTML = newDynamicPriceEls[i].innerHTML;
                    }
                    if (this.QuantityBreaks.hasVariants) {
                        this.QuantityBreaks.variantSelects.forEach(selectItemEl => {
                            selectItemEl.dataset.selectedId = this.currentVariant.id;
                        });
                        const currentVariantSelectEls = this.QuantityBreaks.querySelectorAll('.quantity-break__variant-select');
                        const newVariantSelectEls = newQuantityBreaksEl.querySelectorAll(".quantity-break__variant-select");
                        for (let i = 0; i < currentVariantSelectEls.length; i++) {
                            currentVariantSelectEls[i].innerHTML = newVariantSelectEls[i].innerHTML;
                        }
                        this.QuantityBreaks.initVariants();
                    };
                    if (this.currentVariant.featured_image) {
                        this.QuantityBreaks.querySelectorAll(".quantity-break__selector-item__image img").forEach(imgEl => {
                            imgEl.src = this.currentVariant.featured_image.src;
                        });
                    }
                    if (this.QuantityBreaks.updatePdpPrices) {
                        this.QuantityBreaks.dataset.basePrice = newQuantityBreaksEl.dataset.basePrice;
                        this.QuantityBreaks.labels.forEach(labelEl => {
                            labelEl.dataset.baseComparePrice = newQuantityBreaksEl.querySelector("label[data-input=\"" + labelEl.dataset.input + "\"]").dataset.baseComparePrice;
                        });
                        this.QuantityBreaks.initOfferPrices(true);
                        this.QuantityBreaks.updateInnerPrices();
                    }
                }
                const currentSubWidgetEl = document.getElementById("SubscriptionWidget-" + this.dataset.section);
                const newSubWidgetEl = parsedDoc.getElementById('SubscriptionWidget-' + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section));
                if (currentSubWidgetEl) {
                    if (!newSubWidgetEl) {
                        currentSubWidgetEl.classList.add('hidden');
                    } else {
                        currentSubWidgetEl.dataset.basePrice = newSubWidgetEl.dataset.basePrice || '';
                        currentSubWidgetEl.dataset.baseComparePrice = newSubWidgetEl.dataset.baseComparePrice || '';
                        const planChanged = (currentSubWidgetEl.dataset.firstSellingPlanId || '') !== (newSubWidgetEl.dataset.firstSellingPlanId || '');
                        if (planChanged && typeof currentSubWidgetEl.hydrateFromExternalHTML === 'function') {
                            currentSubWidgetEl.hydrateFromExternalHTML(newSubWidgetEl);
                        } else {
                            const currentOneTimeTexts = currentSubWidgetEl.querySelectorAll(".one-time-price-update");
                            const newOneTimeTexts = newSubWidgetEl.querySelectorAll(".one-time-price-update");
                            for (let i = 0; i < currentOneTimeTexts.length; i++) {
                                currentOneTimeTexts[i].innerHTML = newOneTimeTexts[i].innerHTML;
                            }
                            if (currentSubWidgetEl.updatePrices) {
                                currentSubWidgetEl.updateAllPrices();
                            }
                        }
                    }
                }
                if (this.hasQuantityBreaksPicker) {
                    const newVariantSelectsEl = parsedDoc.getElementById("variant-selects-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section));
                    const currentDynamicPriceEls = this.querySelectorAll(".dynamic-price");
                    const newDynamicPriceEls = newVariantSelectsEl.querySelectorAll('.dynamic-price');
                    for (let i = 0; i < currentDynamicPriceEls.length; i++) {
                        currentDynamicPriceEls[i].innerHTML = newDynamicPriceEls[i].innerHTML;
                    }
                    if (this.quantityBreaksPickerStyle === "vertical" && this.quantityBreaksPickerDisplayedImages === "variant_images") {
                        const currentImgEls = this.querySelectorAll(".quantity-break__image img");
                        const newImgEls = newVariantSelectsEl.querySelectorAll(".quantity-break__image img");
                        for (let i = 0; i < currentImgEls.length; i++) {
                            currentImgEls[i].src = newImgEls[i].src;
                        }
                    }
                    const newQuantityBreakEls = newVariantSelectsEl.querySelectorAll(".quantity-break[data-base-price]");
                    const currentQuantityBreakEls = this.querySelectorAll('.quantity-break');
                    for (let i = 0; i < currentQuantityBreakEls.length && i < newQuantityBreakEls.length; i++) {
                        if (newQuantityBreakEls[i].dataset.basePrice) {
                            currentQuantityBreakEls[i].dataset.basePrice = newQuantityBreakEls[i].dataset.basePrice;
                            currentQuantityBreakEls[i].dataset.baseComparePrice = newQuantityBreakEls[i].dataset.baseComparePrice;
                        }
                    }
                    const subWidgetEl = document.getElementById("SubscriptionWidget-" + this.dataset.section);
                    if (subWidgetEl && subWidgetEl.isSubSelected && this.updateQuantityBreaksPickerPrices) {
                        this.updateQuantityBreaksPickerPrices(subWidgetEl.discountType, subWidgetEl.discountValue, subWidgetEl.moneyFormat);
                    }
                }
                if (this.secondarySelect) {
                    const newSecondarySelectEl = parsedDoc.getElementById('' + this.secondarySelectSelector + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section));
                    if (newSecondarySelectEl) {
                        this.secondarySelect.innerHTML = newSecondarySelectEl.innerHTML;
                    }
                }
                const priceVisibilityEl = document.getElementById("price-" + this.dataset.section);
                if (priceVisibilityEl) {
                    priceVisibilityEl.classList.remove("visibility-hidden");
                }
                this.dataset.options = this.currentVariant.options.join(',');
                if (currentInventoryEl) {
                    currentInventoryEl.classList.toggle('visibility-hidden', newInventoryEl.innerText === '');
                }
                const newSubmitBtnEl = parsedDoc.getElementById('ProductSubmitButton-' + effectiveSection);
                this.toggleAddButton(newSubmitBtnEl ? newSubmitBtnEl.hasAttribute("disabled") : true, window.variantStrings.soldOut);
                publish('variant-change', {
                    'data': {
                        'sectionId': effectiveSection,
                        'html': parsedDoc,
                        'variant': this.currentVariant
                    }
                });
            });
        }
        ['toggleAddButton'](disable = true, disabledText, updateOnly = true) {
            const productFormEl = document.getElementById("product-form-" + this.dataset.section);
            if (!productFormEl) {
                return;
            }
            const addBtnEl = productFormEl.querySelector("[name=\"add\"]");
            if (!addBtnEl) {
                return;
            }
            const mainProductAtcEls = document.querySelectorAll('.main-product-atc');
            var labelTextEl = productFormEl.querySelector(".main-atc__label__text");
            if (!labelTextEl) {
                labelTextEl = productFormEl.querySelector('.main-atc__label');
            }
            const atcPriceEl = productFormEl.querySelector(".main-atc-price");
            const stickyAddBtnEl = document.querySelector(".sticky-atc__add_button");
            let stickyLabelTextEl = null;
            let stickyPriceEl = null;
            if (stickyAddBtnEl) {
                stickyLabelTextEl = stickyAddBtnEl.querySelector(".sticky-atc__label__text");
                stickyPriceEl = stickyAddBtnEl.querySelector(".sticky-atc__button-price");
            }
            if (disable) {
                addBtnEl.setAttribute('disabled', "disabled");
                addBtnEl.setAttribute('data-unavailable', "true");
                if (disabledText && labelTextEl) {
                    labelTextEl.textContent = disabledText;
                }
                if (disabledText && stickyLabelTextEl && stickyAddBtnEl.dataset.label) {
                    stickyLabelTextEl.textContent = disabledText;
                }
                mainProductAtcEls.forEach(btnEl => {
                    btnEl.setAttribute("disabled", 'disabled');
                });
                if (atcPriceEl) {
                    atcPriceEl.classList.add("hidden");
                }
                if (stickyPriceEl) {
                    stickyPriceEl.classList.add("hidden");
                }
            } else {
                addBtnEl.setAttribute('data-unavailable', 'false');
                const label = addBtnEl.dataset.customLabel ?? window.variantStrings.addToCart;
                if (labelTextEl) {
                    labelTextEl.textContent = label;
                }
                if (atcPriceEl) {
                    atcPriceEl.classList.remove("hidden");
                }
                if (stickyLabelTextEl && stickyAddBtnEl.dataset.label) {
                    stickyLabelTextEl.textContent = stickyAddBtnEl.dataset.label;
                }
                if (stickyPriceEl) {
                    stickyPriceEl.classList.remove("hidden");
                }
                if (addBtnEl.dataset.requiredFields === addBtnEl.dataset.validFields) {
                    addBtnEl.removeAttribute("disabled");
                    mainProductAtcEls.forEach(btnEl => {
                        btnEl.removeAttribute("disabled");
                    });
                }
            }
            if (!updateOnly) {
                return;
            }
        }
        ['setUnavailable']() {
            const productFormEl = document.getElementById("product-form-" + this.dataset.section);
            if (!productFormEl) {
                return;
            }
            const addBtnEl = productFormEl.querySelector("[name=\"add\"]");
            var labelTextEl = productFormEl.querySelector('.main-atc__label__text');
            if (!labelTextEl) {
                labelTextEl = productFormEl.querySelector('.main-atc__label');
            }
            const priceEl = document.getElementById('price-' + this.dataset.section);
            const inventoryEl = document.getElementById("Inventory-" + this.dataset.section);
            const skuEl = document.getElementById("Sku-" + this.dataset.section);
            if (!addBtnEl) {
                return;
            }
            if (labelTextEl) {
                labelTextEl.textContent = window.variantStrings.unavailable;
            }
            if (priceEl) {
                priceEl.classList.add("visibility-hidden");
            }
            if (inventoryEl) {
                inventoryEl.classList.add("visibility-hidden");
            }
            if (skuEl) {
                skuEl.classList.add("visibility-hidden");
            }
        }
        ["getVariantData"]() {
            this.variantData = this.variantData || JSON.parse(this.querySelector("[type=\"application/json\"]").textContent);
            return this.variantData;
        }
        ["updateQuantityBreaksPickerPrices"](discountType, discountValue, moneyFormat) {
            if (!this.hasQuantityBreaksPicker) {
                return;
            }
            const breakEls = this.querySelectorAll('.quantity-break');
            if (!breakEls.length) {
                return;
            }
            breakEls.forEach(breakEl => {
                if (!breakEl.dataset.basePrice) {
                    return;
                }
                const basePrice = parseInt(breakEl.dataset.basePrice);
                const baseComparePrice = parseInt(breakEl.dataset.baseComparePrice) || basePrice;
                let price = basePrice;
                if (discountType && discountValue) {
                    if (discountType === "fixed_amount") {
                        price = Math.max(0, basePrice - discountValue);
                    } else {
                        if (discountType === "percentage") {
                            price = Math.round(basePrice * (100 - discountValue) / 100);
                        } else if (discountType === "price") {
                            price = discountValue;
                        }
                    }
                }
                const amountSaved = baseComparePrice - price;
                const amountSavedRounded = Math.round(amountSaved / 100) * 100;
                const percentageSaved = baseComparePrice > 0 ? Math.round(amountSaved / baseComparePrice * 100) : 0;
                const formattedPrice = formatMoney(price, moneyFormat, true);
                const formattedComparePrice = formatMoney(baseComparePrice, moneyFormat, true);
                const formattedAmountSaved = formatMoney(amountSaved, moneyFormat, true);
                const formattedAmountSavedRounded = formatMoney(amountSavedRounded, moneyFormat, true);
                const priceTextEls = breakEl.querySelectorAll(".variant-price-update[data-text]");
                priceTextEls.forEach(textEl => {
                    let text = textEl.dataset.text;
                    text = text.replace("[price]", formattedPrice);
                    text = text.replace('[compare_price]', formattedComparePrice);
                    text = text.replace("[amount_saved]", formattedAmountSaved);
                    text = text.replace("[amount_saved_rounded]", formattedAmountSavedRounded);
                    text = text.replace("[percentage_saved]", percentageSaved + '%');
                    textEl.innerHTML = text;
                });
                const comparePriceEl = breakEl.querySelector(".quantity-break__compare-price");
                if (comparePriceEl) {
                    if (baseComparePrice > price) {
                        comparePriceEl.classList.remove("hidden");
                    } else {
                        comparePriceEl.classList.add("hidden");
                    }
                }
            });
        }
}
customElements.define("variant-selects", VariantSelects);
class SecondaryVariantSelect extends VariantSelects {
    constructor() {
            super();
            this.secondarySelectSelector = "variant-selects-";
            this.secondarySelect = document.getElementById('' + this.secondarySelectSelector + this.dataset.section);
            this.isSecondary = true;
        }
        ["updateOptions"]() {
            this.options = this.querySelector("select").value.split(',');
        }
}
customElements.define("secondary-variant-select", SecondaryVariantSelect);
class SecondaryVariantSelectSeparate extends VariantSelects {
    constructor() {
        super();
        this.secondarySelectSelector = "variant-selects-";
        this.secondarySelect = document.getElementById('' + this.secondarySelectSelector + this.dataset.section);
        this.isSecondary = true;
    }
}
customElements.define("secondary-variant-select-separate", SecondaryVariantSelectSeparate);
class CardVariantSelects extends VariantSelects {
    constructor() {
            super();
            this.quickAddSubmit = document.getElementById(this.dataset.section + "-submit");
        }
        ["onVariantChange"]() {
            this.updateOptions();
            this.updateMasterId();
            this.toggleAddButton(true, '', false);
            this.updateVariantStatuses();
            if (!this.currentVariant) {
                this.toggleAddButton(true, '', true);
                this.setUnavailable();
            } else {
                this.updateMedia();
                this.updateVariantInput();
                this.updateQuickAddUrl();
                this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
            }
        }
        ["updateMedia"]() {
            if (!this.currentVariant || !this.currentVariant.featured_media) {
                return;
            }
            const imageEl = document.getElementById(this.dataset.section + "-image");
            if (!imageEl) {
                return;
            }
            const previewImage = this.currentVariant.featured_media.preview_image;
            const baseSrc = previewImage.src.split('?')[0];
            const widths = [165, 360, 533, 688, 940, 1066];
            const srcsetParts = widths.filter(w => previewImage.width >= w).map(w => baseSrc + "?width=" + w + " " + w + 'w').join(", ");
            imageEl.srcset = srcsetParts + ", " + baseSrc + " " + previewImage.width + 'w';
            imageEl.src = baseSrc + "?width=533";
        }
        ['updateQuickAddUrl']() {
            if (!this.currentVariant || !this.quickAddSubmit) {
                return;
            }
            this.quickAddSubmit.dataset.productUrl = this.dataset.url + "?variant=" + this.currentVariant.id;
        }
}
customElements.define('card-variant-selects', CardVariantSelects);